import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule, Location  } from '@angular/common';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SolicitarVisitaService } from 'src/app/services/solicitar-visita.service';
import { TipoServicioService } from '../../../../services/tipo-servicio.service';
import { SectoresService } from '../../../../services/sectores.service';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { AuthService } from 'src/app/services/auth.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { RepuestosService } from 'src/app/services/repuestos.service';
import { InspectionService } from 'src/app/services/inspection.service';
import { AdvancedImageViewerComponent } from 'src/app/shared/components/advanced-image-viewer/advanced-image-viewer.component';
import { forkJoin, Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, catchError  } from 'rxjs/operators';
import * as L from 'leaflet';
import { UsersService } from 'src/app/services/users.service';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { EspecialidadesService } from '../../../../services/especialidades.service';
import { TipoSolicitudService } from '../../../mantenedores/tipo-solicitud/tipo-solicitud.service';
import { FacturacionService } from 'src/app/services/facturacion.service';
import Swal from 'sweetalert2';
import { MatRadioModule } from '@angular/material/radio';
import { MatRadioGroup } from '@angular/material/radio';
import { UploadDataService } from 'src/app/services/upload-data.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AgregarRepuestoComponent } from 'src/app/components/agregar-repuesto/agregar-repuesto.component';
import { DfontanaService, TypeInventoryItem } from 'src/app/services/dfontana.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { buildDfontanaPayload, getMovementTypeConfig, isValidMovementType } from 'src/app/config/dfontana-movement-types.config';
import { SolicitudStatus } from '../../generar-programacion/generar-programacion.component';
import { StorageService } from '@app/services/storage.service';
import { ActivoFijoLocalService } from '@app/services/activo-fijo-local.service';
import { CausaRaizService } from 'src/app/services/causa-raiz.service'; 

interface Repuesto {
  id: number;
  familia: string;
  articulo: string;
  marca: string;
  precio: number;
  precio_compra?: number;
  precio_venta?: number;
  clima?: boolean;
  valor_uf?: boolean;
  codigoBarra?: string;
}

interface SubItem {
  id: number;
  name: string;
  disabled?: boolean;
  fotos?: string[];
  repuestos?: any[];
  activoId?: number;
}

interface Item {
  id: number;
  name: string;
  estado?: string;
  subItems: SubItem[];
}

interface RepuestoItem {
  estado: string;
  comentario: string;
  fotos: string[];
  repuestos: any[];
}

interface RepuestoMap {
  [key: number]: {
    estado: string;
    comentario: string;
    fotos: string[];
    repuestos: Array<{
      cantidad: number;
      comentario: string;
      repuesto: Repuesto;
    }>;
  };
}

interface Tecnico {
  id: number;
  name: string;
  lastName?: string;
  especialidades: {
    id: number;
    nombre: string;
  }[];
}

interface ActivoFijoRepuesto {
  id: number;
  estadoOperativo: string;
  observacionesEstado: string;
  fechaRevision: string;
  operativo_sin_acceso?: boolean; // Nuevo campo para indicar operativo/no operativo cuando estadoOperativo es 'sin_acceso'
  activoFijo: {
    id: number;
    tipo_equipo: string;
    marca: string;
    potencia_equipo: string;
    codigo_activo: string;
  };
  detallesRepuestos: Array<{
    id: number;
    cantidad: number;
    comentario: string;
    estado: string;
    precio_unitario: string;
    repuesto: {
      id: number;
      familia: string;
      articulo: string;
      marca: string;
      precio: number;
    };
  }>;
}

interface ChecklistItem {
  id: number;
  nombre: string;
  subItems: SubItem[];
}

interface ChecklistCategoria {
  id: number;
  categoria: string;
  items: ChecklistItem[];
}

interface ChecklistResponse {
  data_normal: Array<{
    checklist: ChecklistCategoria[];
  }>;
}

@Component({
  selector: 'app-modificar-solicitud',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTableModule,
    MatExpansionModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    AdvancedImageViewerComponent,
    ConfirmDialogComponent,
    MatRadioModule,
    MatRadioGroup,
    MatInput,
    MatButton,
    MatAutocompleteModule,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './modificar-solicitud.component.html',
  styleUrls: ['./modificar-solicitud.component.scss'],
})
export class ModificarSolicitudComponent implements OnInit, OnDestroy {
  solicitudId: string;
  solicitudForm: FormGroup;
  solicitud: any;
  checklistResponse: any;
  loading = false;
  tipoServicio: any;
  sectorTrabajo: any;
  selectedCompany: any = null;
  listaInspeccion: any[] = [];
  especialidades: any[] = [];
  displayedColumns: string[] = [
    'id',
    'itemId',
    'repuestoId',
    'cantidad',
    'comentario',
    'solicitarVisitaId',
    'articulo',
    'marca',
    'precio',
    'total',
    'acciones',
  ];
  itemRepuestos: any[] = [];
  repuestos: RepuestoMap = {};
  repuestosList: Repuesto[] = [];
  selectedRepuesto: Repuesto | null = null;
  newRepuestoCantidad: number = 1;
  showAddRepuestoForm: { [key: number]: boolean } = {};
  temporaryRepuestos: { [key: number]: any[] } = {};
  temporaryDeletedRepuestos: { [key: number]: any[] } = {};
  tiposServicio: any[] = [];
  tiposSolicitud: any[] = [];
  sectoresTrabajos: any[] = [];
  periodosFacturacion: any[] = [];
  tecnicos: Tecnico[] = [];
  private map: L.Map | null = null;
  esGruman: boolean = false;
  isPendiente: boolean = false;
  isAprobada: boolean = false;
  isRechazada: boolean = false;
  isValidada: boolean = false;
  isReabierta: boolean = false;
  isAtendidaEnProceso: boolean = false;
  isEnServicio: boolean = false;
  isDfontanaDisabled: boolean = false;
  usuarioRechazo: any = null;
  causasRaiz: any[] = [];
  isFinalized: boolean = false;
  isReadOnly: boolean = false;
  checklistColumns: string[] = [
    'activoFijo',
    'setPoint',
    'tempFrio',
    'tempCalor',
    'tempAmbiente',
    'tempRetorno',
    'tempExterior',
    'consumoCompresor',
    'tension',
    'consumoTotal',
    'presiones',
    'fecha',
  ];
  nuevaFechaVisita: Date | null = null;

  urlImage: string | null = null;
  fileName: string = '';
  imagePreview: string | ArrayBuffer | null = null;
  imageBase64: string | null = null;
  temporalChecklist = null;
  otImages: string[] = [];
  isUploadingOT: boolean = false;
  private mapaActivosCache: { [key: string]: any } = {};

  // Variables para control de Autoguardado Reactivo.
  isAutoSaving: boolean = false;
  private isFormInitialized: boolean = false;

  // Subject para manejar el debounce de observaciones
  private observacionesSubject = new Subject<{subItemId: number, observaciones: string, activoFijo: any}>();
  private comentarioGeneralSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  // Tipos de movimiento de inventario Dfontana
  tiposMovimientoInventario: TypeInventoryItem[] = [];
  filteredTiposMovimiento: TypeInventoryItem[] = [];
  tipoMovimientoSearchTerm: string = '';

  @ViewChild('statusDialog') statusDialog: TemplateRef<any>;
  tempNuevoEstado: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private fb: FormBuilder,
    private solicitarVisitaService: SolicitarVisitaService,
    private tipoServicioService: TipoServicioService,
    private tipoSolicitudService: TipoSolicitudService,
    private sectoresService: SectoresService,
    private storage: StorageService,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private dialog: MatDialog,
    private repuestosService: RepuestosService,
    private inspectionService: InspectionService,
    private sectorTrabajoService: SectoresService,
    private usersService: UsersService,
    private especialidadesService: EspecialidadesService,
    private cd: ChangeDetectorRef,
    private causaRaizService: CausaRaizService,
    private uploadDataService: UploadDataService,
    private http: HttpClient,
    private dfontanaService: DfontanaService,
    private facturacionService: FacturacionService,
    private activoFijoLocalService: ActivoFijoLocalService
  ) {
    this.solicitudForm = this.fb.group({
      tipoServicioId: [''],
      sectorTrabajoId: [''],
      especialidad: [''],
      fechaVisita: [{ value: '', disabled: false }, Validators.required],
      ticketGruman: [''],
      observaciones: [''],      
      status: [{ value: '', disabled: true }],
      tecnico_asignado_id: ['', Validators.required],
      tecnico_asignado_id_2: [''],
      fecha_hora_inicio_servicio: [{ value: '', disabled: true }],
      fecha_hora_fin_servicio: [{ value: '', disabled: true }],
      longitud_movil: [''],
      latitud_movil: [''],
      valorPorLocal: [''],
      registroVisita: [''],
      // Campos adicionales de solo lectura
      'local.nombre_local': [{ value: '', disabled: true }],
      'local.direccion': [{ value: '', disabled: true }],
      'client.nombre': [{ value: '', disabled: true }],
      'tecnico_asignado.name': [{ value: '', disabled: true }],
      'tecnico_asignado_2.name': [{ value: '', disabled: true }],
      tipoServicio: [{ value: '', disabled: true }],
      sectorTrabajo: [{ value: '', disabled: true }],
      causaRaizId: [''],
      garantia: [''],
      turno: [''],
      estado_solicitud: [''],
      image_ot: [''],
      tipoMovimientoInventarioId: [''],
      facturacion_id: [{ value: '', disabled: true }]
    });
    this.temporaryRepuestos = {};
    this.temporaryDeletedRepuestos = {};
  }
  
  // --- GRÁFICO DE ESTADOS ---
  // Exponer el Enum a la plantilla HTML
  public EStatus = SolicitudStatus;
  
  // Definición de los pasos visuales del flujo "Feliz"
  public workflowSteps = [
    { label: 'Pendiente de aprobación', icon: 'create_new_folder', states: [SolicitudStatus.PENDIENTE] },
    { label: 'Aprobado', icon: 'assignment_turned_in', states: [SolicitudStatus.APROBADA, SolicitudStatus.REABIERTA] },
    { label: 'Programado', icon: 'event_available', states: [SolicitudStatus.PROGRAMADA] }, 
    { label: 'En servicio', icon: 'engineering', states: [SolicitudStatus.EN_SERVICIO, SolicitudStatus.EN_PROCESO, SolicitudStatus.ATENDIDA_EN_PROCESO] },
    { label: 'Finalizado / Validado', icon: 'task_alt', states: [SolicitudStatus.FINALIZADA, SolicitudStatus.VALIDADA] } 
  ];
  
  // Propiedades de estado para la UI
  public currentActiveStepIndex = 0;
  public isRequestRejected = false;
  public isRequestPaused = false;
  public currentClientLabel = ''; // Para guardar la etiqueta exacta que verá el cliente
  
  /**
   * Calcula el estado del stepper basándose en el estado actual de la solicitud.
   * Llama a este método justo después de cargar los datos de la solicitud (en ngOnInit o getSolicitud).
   * @param status El estado actual de la solicitud (this.solicitudVisita.status)
   */
  public calculateStepperState(status: string): void {
    if (!status) return;
  
    // 1. Detectar estados especiales/terminales negativos
    this.isRequestRejected = status === SolicitudStatus.RECHAZADA;
    
    // Consideramos 'pausado' tanto el estado antiguo como el nuevo.
    this.isRequestPaused = (status === SolicitudStatus.EN_PROCESO || status === SolicitudStatus.ATENDIDA_EN_PROCESO);
  
    // 2. Calcular el índice del paso activo en el flujo "feliz"
    const index = this.workflowSteps.findIndex(step => step.states.includes(status as SolicitudStatus));
    
    if (index !== -1) {
      this.currentActiveStepIndex = index;
    } else if (this.isRequestRejected) {
      // Si está rechazada, visualmente nos quedamos en el paso de "Coordinación" pero marcado en rojo
      this.currentActiveStepIndex = 1; 
    }
  
    // 3. Mapeo exacto de la etiqueta de resumen (Badge).
    this.setClientLabel(status);
  }

  /**
   * Mapea el estado técnico a la etiqueta.
   */
  private setClientLabel(status: string): void {
    switch (status) {
      case SolicitudStatus.PENDIENTE: 
        this.currentClientLabel = 'Pendiente de aprobación'; 
        break;
      case SolicitudStatus.APROBADA: 
        this.currentClientLabel = 'Aprobado'; 
        break;
      case SolicitudStatus.RECHAZADA: 
        this.currentClientLabel = 'Rechazado'; 
        break;
      case SolicitudStatus.PROGRAMADA: 
        this.currentClientLabel = 'Programado'; 
        break;
      case SolicitudStatus.EN_SERVICIO: 
        this.currentClientLabel = 'En servicio'; 
        break;
      case SolicitudStatus.EN_PROCESO: 
      case SolicitudStatus.ATENDIDA_EN_PROCESO: 
        this.currentClientLabel = 'En Proceso'; 
        break;
      case SolicitudStatus.FINALIZADA: 
        this.currentClientLabel = 'Finalizado'; 
        break;
      case SolicitudStatus.VALIDADA: 
        this.currentClientLabel = 'Validado'; 
        break;
      case SolicitudStatus.REABIERTA: 
        // Mantenemos soporte
        this.currentClientLabel = 'Reabierto'; 
        break;
      default: 
        this.currentClientLabel = status;
    }
  }
  
  /**
   * Ayudante para la plantilla HTML para asignar clases CSS dinámicas a cada nodo del stepper.
   */
  public getStepClass(index: number): string {
    let classes = '';
    
    // Estado base del nodo (Completado, Activo, Futuro)
    if (index < this.currentActiveStepIndex) {
      classes += 'step-completed ';
    } else if (index === this.currentActiveStepIndex) {
      classes += 'step-active ';
    } else {
      classes += 'step-future ';
    }
  
    // Modificadores especiales para el nodo ACTIVO
    if (index === this.currentActiveStepIndex) {
      if (this.isRequestRejected) classes += 'is-rejected ';
      if (this.isRequestPaused) classes += 'is-paused ';
      
      // Si es reabierta, le damos un estilo visual de "bucle" o atención
      if (this.solicitud?.status === SolicitudStatus.REABIERTA) classes += 'is-reopened ';
    }
  
    return classes;
  }
  // --- FIN CÓDIGO NUEVO PARA GRÁFICO DE ESTADOS ---

  ngOnInit() {
    // Detectar sincrónicamente si el usuario actual es readonly
    this.isReadOnly = this.authService.currentUserValue?.profile === 'readonly';
    // this.esGruman = this.authService.currentUserValue?.selectedCompany?.nombre?.trim().toUpperCase() === 'GRUMAN';
    const user = this.storage.getItem('currentUser');
    this.selectedCompany = user?.selectedCompany;
    this.esGruman = this.selectedCompany?.nombre === 'GRUMAN';

    // Inicializar explícitamente repuestos como objeto vacío para evitar errores
    this.repuestos = {};

    this.solicitudId = this.route.snapshot.paramMap.get('id') || '';

    // Detectar estado de la solicitud por URL
    const url = this.router.url;
    this.isPendiente = url.includes('pendiente');
    this.isAprobada = url.includes('aprobada');
    this.isRechazada = url.includes('rechazada');
    this.isValidada = url.includes('validada');
    this.isReabierta = url.includes('reabierta');

    this.inicializarFormulario();
    this.loadRepuestos();
    this.loadCatalogos();
    this.loadSolicitud();
    this.cargarTecnicos();
    this.loadEspecialidades();
    this.watchEspecialidadChanges();
    this.watchTipoServicioChanges();
    this.loadCausasRaiz();
    this.setupObservacionesDebounce();
    this.loadTiposMovimientoInventario();

    this.setupComentarioGeneralDebounce();

    this.comentarioGeneralSubject
      .pipe(
        debounceTime(1000), // Espera 1 segundo después de que el usuario deje de escribir
        distinctUntilChanged(), // Solo si el texto realmente cambió
        takeUntil(this.destroy$) // Limpieza al destruir componente
      )
      .subscribe((nuevoComentario: any) => {
        this.ejecutarAutoguardadoComentario(nuevoComentario);
      });

    // Escucha global reactiva para autoguardar campos como Causa Raíz, Turno, etc
    this.solicitudForm.valueChanges
      .pipe(
        debounceTime(1200), // Espera 1.2 segundos de inactividad
        takeUntil(this.destroy$)
      )
      .subscribe((formValues: any) => {
        // Solo autoguardamos si el formulario ya terminó de cargar la data inicial de la BD
        // y si la solicitud está en un estado editable.
        if (this.isFormInitialized && !this.isReadOnly && !this.isValidada && !this.isRechazada && !this.isAprobada) {
          this.ejecutarAutoguardadoFormulario();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupObservacionesDebounce() {
    this.observacionesSubject
      .pipe(
        debounceTime(1000), // Esperar 1 segundo después del último cambio
        // Incluir activoFijo en la comparación para evitar omitir cambios entre activos distintos con mismo subItemId
        distinctUntilChanged((prev: any, curr: any) =>
          prev.subItemId === curr.subItemId &&
          prev.observaciones === curr.observaciones &&
          prev.activoFijo === curr.activoFijo
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(({ subItemId, observaciones, activoFijo }: any) => {
      this.actualizarObservacionesEnChecklistInterno(subItemId, observaciones, activoFijo);
    });
  }

  private setupComentarioGeneralDebounce() {
    this.comentarioGeneralSubject
      .pipe(
        debounceTime(1000), // Espera 1 segundo de silencio
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((comentario: any) => {
        // Llamamos al método 'update' del backend que ya mejoramos
        this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), {
          comentario_general: comentario
        }).subscribe();
      });
  }

  // Método que dispara el evento desde el HTML:
  onComentarioGeneralChange(event: any) {
    const value = event.target.value;
    this.comentarioGeneralSubject.next(value);
  }

  // Validador cruzado al grupo para asegurar que inicio no supere a término
  private validarFechasServicio(group: FormGroup) {
    const inicio = group.get('fecha_hora_inicio_servicio')?.value;
    const fin = group.get('fecha_hora_fin_servicio')?.value;
    if (inicio && fin && new Date(inicio) > new Date(fin)) {
      return { fechaInicioMayorFin: true };
    }
    return null;
  }

  inicializarFormulario() {
    this.solicitudForm = this.fb.group({
      tipoServicioId: [''],
      tipoSolicitudId: [''],
      sectorTrabajoId: [''],
      especialidad: [''],
      fechaVisita: [{ value: '', disabled: false }, Validators.required],
      ticketGruman: [''],
      observaciones: [''],
      comentario_general: [''],
      status: [{ value: '', disabled: true }],
      tecnico_asignado_id: ['', Validators.required],
      tecnico_asignado_id_2: [''],
      fecha_hora_inicio_servicio: [{ value: '', disabled: true }],
      fecha_hora_fin_servicio: [{ value: '', disabled: true }],
      longitud_movil: [''],
      latitud_movil: [''],
      valorPorLocal: [''],
      registroVisita: [''],
      // Campos adicionales de solo lectura
      'local.nombre_local': [{ value: '', disabled: true }],
      'local.direccion': [{ value: '', disabled: true }],
      'client.nombre': [{ value: '', disabled: true }],
      'tecnico_asignado.name': [{ value: '', disabled: true }],
      'tecnico_asignado_2.name': [{ value: '', disabled: true }],
      tipoServicio: [{ value: '', disabled: true }],
      sectorTrabajo: [{ value: '', disabled: true }],
      causaRaizId: [''],
      garantia: ['no'],
      turno: ['diurno'],
      estado_solicitud: ['resuelto'],
      image_ot: [''],
      image_ot_extra: [''],
      tipoMovimientoInventarioId: [''],
      facturacion_id: [{ value: '', disabled: true }]
    }, { validators: this.validarFechasServicio });
    this.temporaryRepuestos = {};
    this.temporaryDeletedRepuestos = {};

    // Add validation for duplicate technicians
    this.solicitudForm
      .get('tecnico_asignado_id')
      ?.valueChanges.subscribe((value: any) => {
        const tecnico2Control = this.solicitudForm.get('tecnico_asignado_id_2');
        if (value && tecnico2Control?.value === value) {
          tecnico2Control?.setValue('');
          Swal.fire({
            title: 'Error',
            text: 'Este técnico ya está seleccionado como Técnico principal',
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
      });

    this.solicitudForm
      .get('tecnico_asignado_id_2')
      ?.valueChanges.subscribe((value: any) => {
        const tecnico1Control = this.solicitudForm.get('tecnico_asignado_id');
        if (value && tecnico1Control?.value === value) {
          this.solicitudForm.get('tecnico_asignado_id_2')?.setValue('');
          Swal.fire({
            title: 'Error',
            text: 'Este técnico ya está seleccionado como Técnico principal',
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
      });
  }

  loadCatalogos(): Promise<void> {
    return new Promise((resolve) => {
      // Usamos forkJoin para cargar todos los catálogos simultáneamente
      forkJoin({
        tiposServicio: this.tipoServicioService.findAll(),
        sectoresTrabajos: this.sectorTrabajoService.getSectores(),
        repuestos: this.repuestosService.getRepuestos(),
      }).subscribe({
        next: (result: any) => {
          this.tiposServicio = result.tiposServicio;
          this.sectoresTrabajos = result.sectoresTrabajos;
          this.repuestos = result.repuestos;
          this.repuestosList = Object.values(result.repuestos);

          console.log('Catálogos cargados:', {
            tiposServicio: this.tiposServicio,
            sectoresTrabajos: this.sectoresTrabajos,
            repuestos: this.repuestos,
          });
          resolve();
        },
        error: (error: any) => {
          console.error('Error loading catálogos:', error);
          this.snackBar.open('Error al cargar los catálogos', 'Cerrar', {
            duration: 3000,
          });
          resolve(); // Resolvemos igual para continuar con la carga
        },
      });
    });
  }

  loadRepuestos() {
  this.repuestosService.getRepuestos().subscribe({
    next: (data: any) => {
      // console.log('Repuestos cargados:', data);
      
      // 1. Convertir los valores del objeto en un arreglo
      const repuestosArray = Object.values(data);

      // 2. Ahora sí puedes usar .map() sobre el arreglo
      this.repuestosList = repuestosArray.map((r: any) => ({
        ...r,
        precio: r.precio_venta || r.precio || 0,
      }));
    },
    error: (error: any) => {
      console.error('Error al cargar repuestos:', error);
      this.snackBar.open('Error al cargar la lista de repuestos', 'Cerrar', {
        duration: 3000,
      });
    },
  });
}

private ejecutarAutoguardadoComentario(comentario: string) {
  this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), {
    comentario_general: comentario
  }).subscribe({
    next: () => {
      // Opcional: mostrar un pequeño aviso o log silencioso
      console.log('Comentario general autoguardado');
    },
    error: (err: any) => console.error('Error en autoguardado:', err)
  });
}

// Método para guardar silenciosamente los campos principales del formulario.
private ejecutarAutoguardadoFormulario() {
    // getRawValue() extrae TODO, incluyendo campos deshabilitados
    const formValues = this.solicitudForm.getRawValue();

    // FIX: Validar que las fechas de servicio no superen el momento actual
    const ahora = new Date();
    if (formValues.fecha_hora_inicio_servicio && new Date(formValues.fecha_hora_inicio_servicio) > ahora) {
      this.snackBar.open('La fecha/hora de inicio de servicio no puede ser mayor a la fecha/hora actual.', 'Cerrar', { duration: 4000, panelClass: ['error-snackbar'] });
      return;
    }
    if (formValues.fecha_hora_fin_servicio && new Date(formValues.fecha_hora_fin_servicio) > ahora) {
      this.snackBar.open('La fecha/hora de término de servicio no puede ser mayor a la fecha/hora actual.', 'Cerrar', { duration: 4000, panelClass: ['error-snackbar'] });
      return;
    }

    this.isAutoSaving = true;

  // Sanitización estricta de llaves foráneas para evitar Error 500 en MariaDB
  const updateData = {
    especialidad: formValues.especialidad ? Number(formValues.especialidad) : null,
    ticketGruman: formValues.ticketGruman || null,
    observaciones: formValues.observaciones || null,
    longitud_movil: formValues.longitud_movil || null,
    latitud_movil: formValues.latitud_movil || null,
    valorPorLocal: formValues.valorPorLocal || 0,
    registroVisita: formValues.registroVisita || null,
    causaRaizId: formValues.causaRaizId ? Number(formValues.causaRaizId) : null,
    garantia: formValues.garantia || 'no',
    turno: formValues.turno || 'diurno',
    estado_solicitud: formValues.estado_solicitud || 'resuelto',
    facturacion_id: formValues.facturacion_id ? Number(formValues.facturacion_id) : null,
    fecha_hora_inicio_servicio: formValues.fecha_hora_inicio_servicio ? new Date(formValues.fecha_hora_inicio_servicio).toISOString() : null,
    fecha_hora_fin_servicio: formValues.fecha_hora_fin_servicio ? new Date(formValues.fecha_hora_fin_servicio).toISOString() : null,
    fechaVisita: formValues.fechaVisita || null,
  };

  this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), updateData).subscribe({
    next: () => {
      // Le damos medio segundo extra al farol verde/apagado para que el usuario alcance a verlo
      setTimeout(() => this.isAutoSaving = false, 800);
      console.log('Formulario base autoguardado en segundo plano');
    },
    error: (err: any) => {
      console.error('Error en autoguardado del formulario:', err);
      this.isAutoSaving = false;
    }
  });
}

onComentarioChange(event: any) {
  this.comentarioGeneralSubject.next(event);
}

loadSolicitud() {
    this.loading = true;
    // Primero cargamos los repuestos para asegurarnos de tener la lista completa
    this.repuestosService.getRepuestos().subscribe({
      next: (repuestos: any[]) => {
        this.repuestosList = repuestos;

        // Ahora cargamos la solicitud
        this.solicitarVisitaService
          .getSolicitudVisita(Number(this.solicitudId))
          .subscribe({
            next: (data: any) => {
              const idEspecialidadOriginal = data.especialidad ? Number(data.especialidad) : null;
              this.solicitud = data;
              this.loading = false;
              this.calculateStepperState(this.solicitud.status);

              // Garantizar la carga de los activos fijos del local si la relación no vino en el objeto solicitud
              const localId = this.solicitud?.local?.id;
              if (localId && (!this.solicitud.local.activoFijoLocales || this.solicitud.local.activoFijoLocales.length === 0)) {
                this.activoFijoLocalService.getActivosFijosByLocal(localId).subscribe({
                  next: (activos: any[]) => {
                    if (this.solicitud?.local) {
                      this.solicitud.local.activoFijoLocales = activos || [];
                    }
                    this.cd.detectChanges();
                  },
                  error: (err: any) => console.error('Error al cargar activos fijos del local:', err)
                });
              }

              // 1. Determinar estados para la lógica de la UI
              this.isPendiente = data.status === 'pendiente';
              this.isAprobada = data.status === 'aprobada';
              this.isRechazada = data.status === 'rechazada';
              this.isValidada = data.status === 'validada';
              this.isReabierta = data.status === 'reabierta';
              this.isEnServicio = data.status === 'en_servicio';
              this.isAtendidaEnProceso = ['programada', 'atendida_en_proceso', 'en_proceso', 'en_servicio'].includes(data.status);
              
              // Forzar modo de solo lectura si la facturación de la OT está cerrada
              if (data.facturacion && data.facturacion.is_cerrada) {
                this.isReadOnly = true;
              }

              // 2. Aplicar deshabilitación general
              if (this.isRechazada || this.isAprobada || this.isValidada || this.isReadOnly) {
                this.deshabilitarControlesFormulario();
              }

              // 3. Lógica específica para el Comentario General
              if (this.isValidada || this.isAprobada || this.isRechazada || this.isReadOnly) { 
                this.solicitudForm.get('comentario_general')?.disable();
              } else {
                this.solicitudForm.get('comentario_general')?.enable();
              }

            // 4. Cargar todos los valores al formulario (incluyendo el comentario)
            this.solicitudForm.patchValue({
              ...data,
              fechaVisita: data.fechaVisita ? new Date(data.fechaVisita) : null,
              comentario_general: data.comentario_general || '',
              sectorTrabajoId: data.sectorTrabajoId || null,
              especialidad: data.especialidad ? Number(data.especialidad) : '',
            });

              this.solicitarVisitaService
                .getSolicitudVisitaChecklist(Number(this.solicitudId))
                .pipe(
                  catchError((error: any) => {
                    console.warn('No se encontró un checklist para esta solicitud, continuando la carga...');
                    return of(null); // <-- Devuelve null si hay error 404
                  })
                )
                .subscribe({
                  next: (checklist: any) => {
                    if (checklist) { // <-- Verificamos si el checklist no es nulo                      
                      this.checklistResponse = checklist;
                      this.temporalChecklist = checklist;

                      // Procesar los repuestos en el checklist
                      if (!this.checklistResponse?.is_climate) {
                        let total_final = 0;
                        this.checklistResponse.data_normal.forEach(
                          (data: any) => {
                            if (data.checklist) {
                              data.checklist.forEach((lista: any) => {
                                if (lista.items) {
                                  lista.items.forEach((item: any) => {
                                    if (item.subItems) {
                                      item.subItems.forEach((subItem: any) => {
                                        // Sanitizar arreglo de fotos antes de mapear
                                        subItem.fotos = this.sanitizeSubItemFotos(subItem.fotos);

                                        if (subItem.repuestos) {
                                          subItem.repuestos = subItem.repuestos.map((repuesto: any) => {
                                            const trueRepuestoId = repuesto.repuesto?.id || repuesto.repuestoId || repuesto.id;
                                            const repuestoDetalle = this.repuestosList.find((r) => r.id === trueRepuestoId);
                                            
                                            // 1. Extraemos los precios CONGELADOS históricos directamente del JSON.
                                            // Priorizamos la raíz (repuesto) y luego el objeto anidado (repuesto.repuesto).
                                            // Fallback final: el catálogo en memoria (repuestoDetalle)
                                            const precioVentaHist = Number(repuesto.precio_venta ?? repuesto.repuesto?.precio_venta ?? repuestoDetalle?.precio_venta ?? 0);
                                            const precioCompraHist = Number(repuesto.precio_compra ?? repuesto.repuesto?.precio_compra ?? repuestoDetalle?.precio_compra ?? 0);
                                            
                                            // 2. Calculamos el total usando el PRECIO DE VENTA (Lo que se factura al cliente)
                                            total_final += precioVentaHist * (repuesto.cantidad || 0);
                                            
                                            return {
                                              ...repuesto,
                                              precio_venta: precioVentaHist,
                                              precio_compra: precioCompraHist, // Dejamos el costo interno disponible en memoria
                                              repuesto: {
                                                ...(repuesto.repuesto || repuestoDetalle || {}),
                                                precio_venta: precioVentaHist,
                                                precio_compra: precioCompraHist
                                              }
                                            };
                                          });
                                        }
                                      });
                                    }
                                  });
                                }
                              });
                            }
                          }
                        );
                        this.checklistResponse.total_final = total_final;
                      } else {
                        let total_final = 0;
                        this.checklistResponse.climate_data.forEach(
                          (activoFijo: any) => {
                            // Búsqueda flexible de activo fijo comparando los IDs convertidos a string
                            const targetId = String(activoFijo.activo_fijo_id).trim();
                            const detailActivoFijo =
                              this.solicitud?.local?.activoFijoLocales?.find(
                                (item: any) => String(item.id).trim() === targetId
                              );

                            // Asignación garantizada usando getActivoFijoDetails en caso de no hallarlo directo en el local
                            activoFijo.detailActivoFijo = detailActivoFijo || this.getActivoFijoDetails(targetId);

                            if (activoFijo.checklist) {
                              activoFijo.checklist.forEach((lista: any) => {
                                if (lista.items) {
                                  lista.items.forEach((item: any) => {
                                    if (item.subItems) {
                                      item.subItems.forEach((subItem: any) => {
                                        // Sanitizar arreglo de fotos
                                        subItem.fotos = this.sanitizeSubItemFotos(subItem.fotos);

                                        // Asignar el activoId al subitem
                                        subItem.activoId = activoFijo.activo_fijo_id;
                                        
                                        if (subItem.repuestos) {
                                          subItem.repuestos = subItem.repuestos.map((repuesto: any) => {
                                            const trueRepuestoId = repuesto.repuesto?.id || repuesto.repuestoId || repuesto.id;
                                            const repuestoDetalle = this.repuestosList.find((r) => r.id === trueRepuestoId);

                                            // 1. Extraemos los precios CONGELADOS históricos directamente del JSON.
                                            // Priorizamos la raíz (repuesto) y luego el objeto anidado (repuesto.repuesto).
                                            // Fallback final: el catálogo en memoria (repuestoDetalle)
                                            const precioVentaHist = Number(repuesto.precio_venta ?? repuesto.repuesto?.precio_venta ?? repuestoDetalle?.precio_venta ?? 0);
                                            const precioCompraHist = Number(repuesto.precio_compra ?? repuesto.repuesto?.precio_compra ?? repuestoDetalle?.precio_compra ?? 0);
                                            
                                            // 2. Calculamos el total usando el PRECIO DE VENTA (Lo que se factura al cliente)
                                            total_final += precioVentaHist * (repuesto.cantidad || 0);
                                            
                                            return {
                                              ...repuesto,
                                              precio_venta: precioVentaHist,
                                              precio_compra: precioCompraHist, // Dejamos el costo interno disponible en memoria
                                              repuesto: {
                                                ...(repuesto.repuesto || repuestoDetalle || {}),
                                                precio_venta: precioVentaHist,
                                                precio_compra: precioCompraHist
                                              }
                                            };
                                          });
                                        }
                                      });
                                    }
                                  });
                                }
                              });
                            }
                            // if (activoFijo.repuestos) {
                            //   activoFijo.repuestos = activoFijo.repuestos.map((repuesto: any) => {
                            //     const repuestoDetalle = this.repuestosList.find(r => r.id === repuesto.id);
                            //     console.log(repuestoDetalle);
                            //     total_final += (repuestoDetalle?.precio_venta || 0) * (repuesto.cantidad || 0);
                            //     return {
                            //       ...repuesto,
                            //       repuesto: repuestoDetalle || null
                            //     };
                            //   });
                            // }
                          }
                        );
                        this.checklistResponse.total_final = total_final;
                      }
                    } else {
                      this.checklistResponse = null; // Asignamos null si no se encontró
                    }
                  },
              });

            // ❌ AQUÍ ESTABA EL BLOQUE DUPLICADO getSolicitudVisitaChecklist, SE BORRAR ❌
            
              this.solicitud = data;

              // Cargar tipos de solicitud
              if (data.client?.id) {
                this.loadTiposSolicitud(data.client.id);
              }

              // Mantiene compatibilidad local/Firebase
              this.otImages = [];
              const parseUrl = (url: string) => url.startsWith('http') ? url : `${environment.apiUrl}/${url}`;

              // 1. Cargar imagen principal (la que lee la APK)
              if (data.image_ot) {
                this.otImages.push(parseUrl(data.image_ot));
              }

              // 2. Cargar imágenes extra si existen (separadas por coma)
              if (data.image_ot_extra) {
                const extras = data.image_ot_extra.split(',').filter((u: string) => u.trim() !== '');
                extras.forEach((extraUrl: string) => {
                  this.otImages.push(parseUrl(extraUrl));
                });
              }

              this.solicitudForm.patchValue({
                image_ot: data.image_ot || '',
                image_ot_extra: data.image_ot_extra || ''
              });

              // Detectar estado de la solicitud por su estado actual
              if (this.solicitud?.status === 'pendiente') {
                this.isPendiente = true;
              } else if (this.solicitud?.status === 'aprobada') {
                this.isAprobada = true;
              } else if (this.solicitud?.status === 'rechazada') {
                this.isRechazada = true;

                // Cargar la información del usuario que rechazó la solicitud
                if (this.solicitud?.rechazada_por_id) {
                  this.loading = true; // Mantener loading mientras cargamos datos adicionales
                  this.usersService
                    .getUserById(this.solicitud.rechazada_por_id)
                    .subscribe({
                      next: (usuario: any) => {
                        this.usuarioRechazo = usuario;
                        console.log(
                          'Usuario que rechazó la solicitud:',
                          usuario
                        );
                      },
                      error: (error: any) => {
                        console.error(
                          'Error al cargar información del usuario que rechazó:',
                          error
                        );
                        this.snackBar.open(
                          'No se pudo cargar la información completa del usuario que rechazó la solicitud',
                          'Cerrar',
                          {
                            duration: 5000,
                          }
                        );
                      },
                      complete: () => {
                        this.loading = false;
                      },
                    });
                } else {
                  console.warn(
                    'La solicitud está rechazada pero no tiene rechazada_por_id'
                  );
                }
              } else if (this.solicitud?.status === 'validada') {
                this.isValidada = true;
              } else if (this.solicitud?.status === 'reabierta') {
                this.isReabierta = true;
              } else if (this.solicitud?.status === 'atendida_en_proceso') {
                // CR-202608-0034 - Marcar explícitamente el flag para la vista
                this.isAtendidaEnProceso = true;
              }

              // Si el estado es pendiente, aprobada (Gruman) o en proceso, habilitar los controles necesarios
              if (this.isPendiente || this.isAtendidaEnProceso || (this.isAprobada && this.esGruman)) {
                this.solicitudForm.get('tecnico_asignado_id')?.enable();
                this.solicitudForm.get('tecnico_asignado_id_2')?.enable();
                this.solicitudForm.get('sectorTrabajoId')?.enable();
                this.solicitudForm.get('especialidad')?.enable();
                // Estos dos se quedan solo para pendiente
                if (this.isPendiente) {
                  this.solicitudForm.get('tipoServicioId')?.enable();
                  this.solicitudForm.get('tipoSolicitudId')?.enable();
                }
              } else {
                // Si no, deshabilitar los controles
                this.solicitudForm.get('tecnico_asignado_id')?.disable();
                
                //  Habilitar técnico 2 en la validación (estado finalizada o reabierta) (CR-202610-0004)
                if ((this.solicitud?.status === 'finalizada' || this.solicitud?.status === 'reabierta') && !this.isReadOnly) {
                  this.solicitudForm.get('tecnico_asignado_id_2')?.enable();
                } else {
                  this.solicitudForm.get('tecnico_asignado_id_2')?.disable();
                }

                this.solicitudForm.get('tipoServicioId')?.disable();
                this.solicitudForm.get('tipoSolicitudId')?.disable();
                this.solicitudForm.get('sectorTrabajoId')?.disable();
                this.solicitudForm.get('especialidad')?.disable();
              }

              // CR-202608-0034 - Habilitar las fechas de servicio e imágenes de respaldo si está en atendida_en_proceso
              if ((this.solicitud?.status === 'finalizada' || this.isReabierta || this.solicitud?.status === 'reabierta' || this.isAtendidaEnProceso || this.solicitud?.status === 'atendida_en_proceso') && !this.isReadOnly) {
                this.solicitudForm.get('fecha_hora_inicio_servicio')?.enable();
                this.solicitudForm.get('fecha_hora_fin_servicio')?.enable();
              } else {
                this.solicitudForm.get('fecha_hora_inicio_servicio')?.disable();
                this.solicitudForm.get('fecha_hora_fin_servicio')?.disable();
              }

              // aDesbloqueo para tickets Finalizados
              const estadoAct = data.status?.toLowerCase();
              if (!this.isReadOnly && estadoAct !== 'validada' && estadoAct !== 'rechazada') {
                this.solicitudForm.get('facturacion_id')?.enable({ emitEvent: false });
              } else {
                this.solicitudForm.get('facturacion_id')?.disable({ emitEvent: false });
              }

              this.itemRepuestos = data.itemRepuestos || [];

              // Encontrar los nombres de tipo servicio y sector trabajo
              const tipoServicio = this.tiposServicio.find(
                (t) => t.id === data.tipoServicioId
              );
              const sectorTrabajo = this.sectoresTrabajos.find(
                (s) => s.id === data.sectorTrabajoId
              );

              // Actualizar el formulario con los datos
              this.solicitudForm.patchValue({
                'client.nombre': data.client?.nombre || '',
                'local.nombre_local': data.local?.nombre_local || '',
                'local.direccion': data.local?.direccion || '',
                'tecnico_asignado.name': data.tecnico_asignado?.name || '',
                tipoServicioId:  data.tipoServicioId || data.tipoServicio?.id || '',
                tipoSolicitudId: data.tipoSolicitudId || '',
                sectorTrabajoId: data.sectorTrabajoId || '',
                // especialidad: data.especialidad || '',
                fechaVisita: data.fechaVisita
                  ? new Date(data.fechaVisita)
                  : null,
                ticketGruman: data.ticketGruman || '',
                status: data.status || '',
                observaciones: data.observaciones || '',
                fecha_hora_inicio_servicio: this.formatForDateTimeLocal(data.fecha_hora_inicio_servicio),
                fecha_hora_fin_servicio: this.formatForDateTimeLocal(data.fecha_hora_fin_servicio),                
                longitud_movil: data.longitud_movil || '',
                latitud_movil: data.latitud_movil || '',
                valorPorLocal:
                  data.valorPorLocal !== null
                    ? data.valorPorLocal
                    : data.local?.valorPorLocal || '',
                registroVisita: data.registroVisita || '',
                tecnico_asignado_id: data.tecnico_asignado?.id || '',
                tecnico_asignado_id_2: data.tecnico_asignado_2?.id || '',
                tipoServicio: data.tipoServicio?.nombre || '',
                sectorTrabajo: data.sectorTrabajo?.nombre || '',
                causaRaizId: data.causaRaizId || '',
                garantia: data.garantia || 'no',
                turno: data.turno || 'diurno',
                estado_solicitud: data.estado_solicitud || 'resuelto',
                facturacion_id: data.facturacion?.id_facturacion || data.facturacion_id || '',
              });

              setTimeout(() => {
                if (idEspecialidadOriginal) {
                  console.log('=== CONTROL DE ESPECIALIDAD TICKET ' + this.solicitudId + ' ===');
                  console.log('Match Exitoso. Seteando ID en el Formulario:', idEspecialidadOriginal);

                  // Seteamos el valor usando { emitEvent: false } para evitar bucles de eventos secundarios
                  this.solicitudForm.get('especialidad')?.setValue(idEspecialidadOriginal, { emitEvent: false });
                  
                  // Forzamos el renderizado visual en el DOM
                  this.cd.detectChanges(); 
                } else {
                  console.log('=== CONTROL DE ESPECIALIDAD TICKET ' + this.solicitudId + ' ===');
                  console.log('El ticket original no posee ninguna especialidad asociada.');
                }
              }, 300);

              if (data.client?.id) {
                this.http.get<any[]>(`${environment.apiUrl}/facturacion/${data.client.id}`).subscribe({
                  next: (facts: any) => {
                    if (Array.isArray(facts)) {
                      // Los ordenamos del más reciente al más antiguo para que sea fácil elegir
                      this.periodosFacturacion = facts.sort((a, b) => 
                        new Date(b.fecha_inicio).getTime() - new Date(a.fecha_inicio).getTime()
                      );
                    }
                  },
                  error: (err: any) => console.error('Error al cargar facturaciones del cliente', err)
                });
              }

              // Si está rechazada, deshabilitar todos los controles
              if (this.isRechazada) {
                this.deshabilitarControlesFormulario();
              }

              // Si está aprobada, también deshabilitar todos los controles
              if (this.isAprobada) {
                this.deshabilitarControlesFormulario();
              }

              // Si está validada, también deshabilitar todos los controles
              if (this.isValidada) {
                this.deshabilitarControlesFormulario();
                // Asegurarse explícitamente que registroVisita esté deshabilitado
                this.solicitudForm.get('registroVisita')?.disable();
              }

              // Si está reabierta, NO deshabilitar controles relacionados con valorPorLocal
              if (this.isReabierta || this.solicitud?.status === 'reabierta') {
                // Asegurarse que el campo valorPorLocal esté habilitado
                this.solicitudForm.get('valorPorLocal')?.enable();
              }             

              // Procesar lista de inspección
              if (data.client?.listaInspeccion) {
                this.listaInspeccion = data.client.listaInspeccion.map(
                  (lista: any) => ({
                    ...lista,
                    items: lista.items.map((item: any) => ({
                      ...item,
                      subItems: item.subItems.map((subItem: any) => {
                        // Filtrar los repuestos para este subItem
                        const subItemRepuestos = this.itemRepuestos.filter(
                          (repuesto) => repuesto.itemId === subItem.id
                        );

                        // Obtener el último repuesto para determinar el estado
                        const lastRepuesto = subItemRepuestos.sort(
                          (a, b) =>
                            new Date(b.fechaAgregado).getTime() -
                            new Date(a.fechaAgregado).getTime()
                        )[0];

                        // Obtener todas las fotos de los repuestos
                        const fotos = subItemRepuestos.reduce(
                          (acc: string[], repuesto: any) => {
                            if (
                              repuesto.fotos &&
                              Array.isArray(repuesto.fotos)
                            ) {
                              return [...acc, ...repuesto.fotos];
                            }
                            return acc;
                          },
                          []
                        );

                        // Asignar las fotos al repuesto en el mapa de repuestos
                        if (!this.repuestos[subItem.id]) {
                          this.repuestos[subItem.id] = {
                            estado:
                              lastRepuesto?.estado ||
                              subItem.estado ||
                              'no_conforme',
                            comentario: lastRepuesto?.comentario || '',
                            fotos: fotos,
                            repuestos: [],
                          };
                        }

                        return {
                          ...subItem,
                          estado:
                            lastRepuesto?.estado ||
                            subItem.estado ||
                            'no_conforme',
                          fotos: fotos,
                          repuestos: subItemRepuestos,
                        };
                      }),
                    })),
                  })
                );
              }

              // Actualizar el mapa de repuestos con los repuestos existentes
              if (!this.repuestos) {
                this.repuestos = {}; // Asegurar que repuestos esté inicializado
              }

              this.itemRepuestos.forEach((repuesto) => {
                const itemId = repuesto.itemId;

                // Verificar si itemId es válido
                if (itemId === undefined || itemId === null) {
                  console.warn(
                    'Se encontró un repuesto sin itemId válido:',
                    repuesto
                  );
                  return; // Saltar a la siguiente iteración
                }

                if (!this.repuestos[itemId]) {
                  this.repuestos[itemId] = {
                    estado: repuesto.estado || 'no_conforme',
                    comentario: repuesto.comentario || '',
                    fotos: repuesto.fotos || [],
                    repuestos: [], // Inicializar como array vacío
                  };
                }

                // Asegurar que repuestos sea un array
                if (!this.repuestos[itemId].repuestos) {
                  this.repuestos[itemId].repuestos = [];
                }

                // Ahora es seguro hacer push
                this.repuestos[itemId].repuestos.push({
                  cantidad: repuesto.cantidad || 0,
                  comentario: repuesto.comentario || '',
                  repuesto: repuesto.repuesto,
                });
              });

              // Inicializar el mapa después de un pequeño retraso para asegurar que el DOM esté listo
              setTimeout(() => {
                this.initMap();
                this.isFormInitialized = true; //  Habilitamos la escucha de autoguardado.
              }, 100);
              console.log('Repuestos cargados:', this.repuestos);
              this.loading = false;

              console.log('Repuestos cargados:', this.repuestos);
              this.loading = false;
            },
            error: (error: any) => {
              console.error('Error loading solicitud:', error);
              this.loading = false;
              // Extraemos el mensaje del backend si existe, si no, usamos el genérico
              const errorMessage = error.error?.message || 'Error al cargar la solicitud';
              
              this.snackBar.open(errorMessage, 'Cerrar', {
                duration: 5000, // Aumentamos un poco la duración para leer mejor
                panelClass: ['error-snackbar']
              });
            },
          });
      },
      error: (error: any) => {
        console.error('Error loading repuestos:', error);
        this.loading = false;
        this.snackBar.open('Error al cargar la lista de repuestos', 'Cerrar', {
          duration: 3000,
        });
      },
    });
  }

  getRepuestosChecklist(checklist: any) {
    this.solicitarVisitaService
      .getRepuestosById(checklist)
      .subscribe((res: any) => {
        console.log(res);
      });
  }
  onCancel(): void {
    this.location.back();
  }

  hasPhotos(subItem: any, activoFijo: any) {
    return (
      this.solicitud?.itemFotos?.find(
        (item: any) =>
          item.itemId.toString() === subItem.toString() &&
          item.activo_fijo_id.toString() === activoFijo.toString()
      )?.fotos || []
    );
  }

  hasItemStatus(subItem: any, activoFijo: any) {
    return (
      this.solicitud?.itemEstados?.find(
        (item: any) =>
          item.itemId.toString() === subItem.toString() &&
          item.activo_fijo_id.toString() === activoFijo.toString()
      ) || []
    );
  }

  hasReplacements(subItem: any, activoFijo: any) {
    return (
      this.solicitud?.itemRepuestos?.filter(
        (item: any) =>
          item.itemId.toString() === subItem.toString() &&
          item.activo_fijo_id.toString() === activoFijo.toString()
      ) || []
    );
  }

  // -------------------------------------------------------------------------
  // FLUJO 1: APROBAR SOLICITUD (Desde bandeja de Pendientes)
  // -------------------------------------------------------------------------
  aprobarSolicitud(): void {
    if (this.isReadOnly) return;
    
    const currentUser = this.authService.currentUserValue;
    const formValues = this.solicitudForm.getRawValue();

    // 🛠️ FIX: Normalización defensiva para evitar cadenas vacías o NaN en tecnico_asignado_id_2
    const rawTec2Aprobar = formValues.tecnico_asignado_id_2;
    const dataParaAprobar = {
      tecnico_asignado_id: formValues.tecnico_asignado_id ? Number(formValues.tecnico_asignado_id) : null,
      tecnico_asignado_id_2: (rawTec2Aprobar !== null && rawTec2Aprobar !== '' && rawTec2Aprobar !== undefined) ? Number(rawTec2Aprobar) : null,
      especialidad: formValues.especialidad || null,
      fechaVisita: formValues.fechaVisita || null,
      valorPorLocal: formValues.valorPorLocal || 0,
      aprobada_por_id: currentUser?.id ? Number(currentUser.id) : null,
      
      // REQUERIMIENTO CR-202606-0007: Se agregan los parámetros omitidos
      tipoServicioId: formValues.tipoServicioId ? Number(formValues.tipoServicioId) : null,
      tipoSolicitudId: formValues.tipoSolicitudId ? Number(formValues.tipoSolicitudId) : null
    };

    this.loading = true;
    
    this.solicitarVisitaService.aprobarSolicitudVisita(Number(this.solicitudId), dataParaAprobar).subscribe({
      next: (res: any) => {
        const finalStatus = res?.status === 'programada' ? 'Programada' : 'Aprobada';
        this.snackBar.open(`Solicitud ${finalStatus} correctamente`, 'Cerrar', { duration: 3000 });
        
        // Volver simple con Refresh forzado a Pendientes
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigate(['/transacciones/solicitudes-de-visita/pendientes']);
        });
      },
      error: (error: any) => {
        console.error('Error al procesar la solicitud:', error);
        this.snackBar.open('Error al procesar la solicitud. Verifique los datos.', 'Cerrar', { duration: 5000, panelClass: ['error-snackbar'] });
        this.loading = false;
      }
    });
  }

  // -------------------------------------------------------------------------
  // FLUJO 2: PROGRAMAR VISITA TÉCNICA (Desde bandeja de Aprobadas)
  // -------------------------------------------------------------------------
  programarVisitaTecnica(): void {
    if (this.isReadOnly) return;
    const currentUser = this.authService.currentUserValue;
    const formValues = this.solicitudForm.getRawValue();

    this.loading = true;

    // 1. Limpiamos los datos y los preparamos (Evita el Error 500)
    // Normalización de tecnico_asignado_id_2 para evitar campos vacíos que causen NaN o errores de columna
    const rawTec2Prog = formValues.tecnico_asignado_id_2;
    const updateData = {
      tecnico_asignado_id: formValues.tecnico_asignado_id ? Number(formValues.tecnico_asignado_id) : null,
      tecnico_asignado_id_2: (rawTec2Prog !== null && rawTec2Prog !== '' && rawTec2Prog !== undefined) ? Number(rawTec2Prog) : null,
      fechaVisita: formValues.fechaVisita || null,
      especialidad: formValues.especialidad || null,
      sectorTrabajoId: formValues.sectorTrabajoId ? Number(formValues.sectorTrabajoId) : null,
      valorPorLocal: formValues.valorPorLocal || 0,
    };

    // 2. Primero usamos el endpoint UPDATE para guardar todos los campos de forma segura
    this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), updateData).subscribe({
      next: () => {
        // 3. Forzamos el cambio de estado a PROGRAMADA mediante el endpoint dedicado del backend
        const payloadProgramar = {
          tecnico_asignado_id: updateData.tecnico_asignado_id,
          fechaVisita: updateData.fechaVisita,
          programada_por_id: currentUser?.id
        };

        this.solicitarVisitaService.programarSolicitud(Number(this.solicitudId), payloadProgramar).subscribe({
          next: () => {
            this.snackBar.open('Visita Programada exitosamente', 'Cerrar', { duration: 3000 });
            
            // Volver simple con Refresh forzado a Aprobadas
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                this.router.navigate(['/transacciones/solicitudes-de-visita/aprobadas']);
            });
          },
          error: (err: any) => {
            console.error('Error al programar:', err);
            this.snackBar.open('Error al cambiar el estado a Programada', 'Cerrar', { duration: 3000, panelClass: ['error-snackbar'] });
            this.loading = false;
          }
        });
      },
      error: (err: any) => {
        console.error('Error al actualizar datos:', err);
        this.snackBar.open('Error al guardar los datos técnicos. Verifique los campos.', 'Cerrar', { duration: 3000, panelClass: ['error-snackbar'] });
        this.loading = false;
      }
    });
  }
  
  rechazarSolicitud(): void {
    if (this.isReadOnly) return;
    // Diálogo para pedir motivo de rechazo
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: {
        title: 'Rechazar Solicitud',
        message: '¿Estás seguro de que deseas rechazar esta solicitud?',
        inputLabel: 'Motivo del rechazo',
        inputPlaceholder: 'Ingrese el motivo del rechazo',
        requireInput: true, // Requiere que se ingrese un motivo
        confirmText: 'Rechazar',
        cancelText: 'Cancelar',
        confirmColor: 'warn',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
          this.loading = true;

        // Obtenemos la información del usuario actual
        const currentUser = this.authService.currentUserValue;
        console.log('Usuario actual:', currentUser);

        this.solicitarVisitaService
          .rechazarSolicitudVisita(Number(this.solicitudId), {
            motivo: result,
            rechazada_por_id: currentUser?.id,
          })
          .subscribe({
            next: () => {
              this.snackBar.open(
                'Solicitud rechazada correctamente',
                'Cerrar',
                {
                  duration: 3000,
                }
              );
              this.router.navigate(['/transacciones/solicitudes-de-visita']);
            },
            error: (error: any) => {
              console.error('Error al rechazar la solicitud:', error);
              this.snackBar.open('Error al rechazar la solicitud', 'Cerrar', {
                duration: 3000,
              });
              this.loading = false;
            },
            complete: () => {
              this.loading = false;
            },
          });
      }
    });
  }

  onSaveRepuestos(): void {
    // Si la solicitud está rechazada, no permitir guardar repuestos
    if (this.isRechazada) {
      return;
    }

    console.log('this.checklistResponse', this.checklistResponse);

    this.solicitarVisitaService
      .updateChecklistVisita(Number(this.solicitudId), {
        is_climate: this.checklistResponse.is_climate,
        data: this.checklistResponse,
      })
      .subscribe((res: any) => {
        console.log('RESPUESTA ENDPOINT', res);
        if (res.success) {
          this.snackBar.open('Repuestos guardados correctamente', 'Cerrar', {
            duration: 3000,
          });
        } else {
          this.snackBar.open('Error al guardar los repuestos', 'Cerrar', {
            duration: 3000,
          });
        }
      });
  }

  // Método auxiliar para encontrar un subItem por su ID
  private findSubItemById(subItemId: number): any {
    if (!this.listaInspeccion) return null;

    for (const lista of this.listaInspeccion) {
      for (const item of lista.items) {
        for (const subItem of item.subItems) {
          if (subItem.id === subItemId) {
            return subItem;
          }
        }
      }
    }

    return null;
  }

  onValidate(): void {
    if (this.isReadOnly) return;
    
    // Si la solicitud está rechazada, no permitir validar
    if (this.isRechazada) {
      return;
    }

    // Validar campos requeridos cuando el estado es finalizado
    if (this.solicitud?.status === 'finalizada') {
      const formValues = this.solicitudForm.getRawValue();

      // FIX: Validar que fecha inicio/término no sean mayores al día/hora actual
      const ahora = new Date();
      if (formValues.fecha_hora_inicio_servicio && new Date(formValues.fecha_hora_inicio_servicio) > ahora) {
        this.snackBar.open('La fecha/hora de inicio de servicio no puede ser mayor a la fecha/hora actual.', 'Cerrar', { duration: 4000, panelClass: ['error-snackbar'] });
        return;
      }
      if (formValues.fecha_hora_fin_servicio && new Date(formValues.fecha_hora_fin_servicio) > ahora) {
        this.snackBar.open('La fecha/hora de término de servicio no puede ser mayor a la fecha/hora actual.', 'Cerrar', { duration: 4000, panelClass: ['error-snackbar'] });
        return;
      }

      // Validar en el cliente que el inicio no sea mayor que el término
      if (formValues.fecha_hora_inicio_servicio && formValues.fecha_hora_fin_servicio) {
        if (new Date(formValues.fecha_hora_inicio_servicio) > new Date(formValues.fecha_hora_fin_servicio)) {
          this.snackBar.open('La fecha/hora de inicio no puede ser mayor a la fecha/hora de término.', 'Cerrar', { duration: 4000, panelClass: ['error-snackbar'] });
          return;
        }
      }

      if (!formValues.garantia) {
        this.snackBar.open('Debe seleccionar si aplica garantía', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
        return;
      }

      if (!formValues.turno) {
        this.snackBar.open('Debe seleccionar el turno', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
        return;
      }

      if (!formValues.estado_solicitud) {
        this.snackBar.open(
          'Debe seleccionar el estado de la solicitud',
          'Cerrar',
          {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          }
        );
        return;
      }
    }

    console.log('Iniciando validación...');
    this.authService.currentUser.subscribe((currentUser: any) => {
      if (!currentUser || !currentUser.id) {
        this.snackBar.open(
          'Error: No se pudo obtener el usuario actual',
          'Cerrar',
          {
            duration: 3000,
          }
        );
        return;
      }
      // console.log('this.temporaryDeletedRepuestos', this.temporaryDeletedRepuestos);
      // // Primero eliminamos los repuestos marcados para eliminar
      // for (const subItemId in this.temporaryDeletedRepuestos) {
      //   for (const repuesto of this.temporaryDeletedRepuestos[subItemId]) {
      //     console.log('repuesto', repuesto.id);
      //     this.inspectionService.deleteRepuestoFromItem(repuesto.id).subscribe({
      //       next: () => {
      //         console.log('Repuesto eliminado correctamente');
      //       },
      //       error: (error: any) => {
      //         console.error('Error al eliminar repuesto:', error);
      //       }
      //     });
      //   }
      // }

      // Primero actualizamos los datos del formulario
      const formValues = this.solicitudForm.getRawValue();
      const updateData = {
        especialidad: formValues.especialidad ? Number(formValues.especialidad) : null,
        ticketGruman: formValues.ticketGruman || null,
        observaciones: formValues.observaciones || null,
        longitud_movil: formValues.longitud_movil || null,
        latitud_movil: formValues.latitud_movil || null,
        valorPorLocal: formValues.valorPorLocal || 0,
        registroVisita: formValues.registroVisita || null,
        garantia: formValues.garantia || 'no',
        turno: formValues.turno || 'diurno',
        estado_solicitud: formValues.estado_solicitud || 'resuelto',
        facturacion_id: formValues.facturacion_id ? Number(formValues.facturacion_id) : null,
        image_ot: this.otImages.length > 0 ? this.otImages[0] : '',
        image_ot_extra: this.otImages.length > 1 ? this.otImages.slice(1).join(',') : '',
        fecha_hora_inicio_servicio: formValues.fecha_hora_inicio_servicio || null,
        fecha_hora_fin_servicio: formValues.fecha_hora_fin_servicio || null,
        fechaVisita: formValues.fechaVisita || null,
        listaInspeccion: this.listaInspeccion.map((lista) => ({
          ...lista,
          items: lista.items.map((item: any) => ({
            ...item,
            subItems: item.subItems.map((subItem: any) => ({
              ...subItem,
            })),
          })),
        })),
      };

      // //agregar los items aca de temporalRepuestos
      // console.log('temporalRepuestos', this.temporaryRepuestos);
      // for (const subItemId in this.temporaryRepuestos) {
      //   for (const repuesto of this.temporaryRepuestos[subItemId]) {
      //     this.inspectionService.insertRepuestoInItem(this.solicitud?.client?.id, subItemId, repuesto.repuesto.id, repuesto.cantidad, repuesto.comentario, Number(this.solicitudId)).subscribe({
      //       next: () => {
      //         console.log('Repuesto agregado correctamente');
      //       },
      //       error: (error: any) => {
      //         console.error('Error al agregar repuesto:', error);
      //       }
      //     });
      //   }
      // }

      // Actualizar primero los datos del formulario
      this.solicitarVisitaService
        .updateSolicitudVisita(Number(this.solicitudId), updateData)
        .subscribe({
          next: () => {
            // FIX: CR-202610-0008 - Asignar correctamente las fechas de inicio y término sin invertir los campos
            const validationData = {
              validada_por_id: currentUser?.id || null,
              especialidad: formValues.especialidad ? Number(formValues.especialidad) : null,
              ticketGruman: formValues.ticketGruman || null,
              observaciones: formValues.observaciones || null,
              longitud_movil: formValues.longitud_movil || null,
              latitud_movil: formValues.latitud_movil || null,
              registroVisita: formValues.registroVisita || null,
              causaRaizId: formValues.causaRaizId ? Number(formValues.causaRaizId) : null,
              valorPorLocal: formValues.valorPorLocal ? Number(formValues.valorPorLocal) : 0,
              garantia: formValues.garantia || null,
              turno: formValues.turno || null,
              estado_solicitud: formValues.estado_solicitud || null,
              image_ot: this.otImages.length > 0 ? this.otImages[0] : '',
              image_ot_extra: this.otImages.length > 1 ? this.otImages.slice(1).join(',') : '',
              fecha_hora_inicio_servicio: formValues.fecha_hora_inicio_servicio || null,
              fecha_hora_fin_servicio: formValues.fecha_hora_fin_servicio || null,
              fechaVisita: formValues.fechaVisita || null,
            };

            this.solicitarVisitaService
              .validarSolicitud(Number(this.solicitudId), validationData)
              .subscribe({
                next: (response: any) => {
                  console.log('Validación exitosa:', response);
                  this.snackBar.open(
                    'Solicitud validada correctamente',
                    'Cerrar',
                    {
                      duration: 3000,
                    }
                  );

                  // Verificar si hay tipo de movimiento de inventario seleccionado
                  const tipoMovimiento = this.solicitudForm.get('tipoMovimientoInventarioId')?.value;

                  if (tipoMovimiento) {
                    console.log('📦 Procesando descuento de inventario en Dfontana...');
                    this.procesarDescuentoInventario(tipoMovimiento);
                  }

                  // EJECUTAR ENVIO DE EMAIL
                  this.solicitarVisitaService
                    .enviarEmail(Number(this.solicitudId))
                    .subscribe({
                      next: (response: any) => {
                        console.log('Email enviado correctamente:', response);
                      },
                      error: (error: any) => {
                        console.error('Error al enviar el email:', error);
                      },
                    });

                  this.router.navigate([
                    '/transacciones/solicitudes-de-visita/validadas',
                  ]);
                },
                error: (error: any) => {
                  console.error('Error en validación:', error);
                  this.snackBar.open(
                    'Error al validar la solicitud',
                    'Cerrar',
                    {
                      duration: 3000,
                    }
                  );
                },
              });
          },
          error: (error: any) => {
            console.error('Error al actualizar la solicitud:', error);
            this.snackBar.open(
              'Error al actualizar los datos de la solicitud',
              'Cerrar',
              {
                duration: 3000,
              }
            );
          },
        });
    });
  }

  // Método proactivo para autoguardado de técnico asignado
  onTecnicoAsignadoChange(tecnicoId: number | null): void {
    const payload = { tecnico_asignado_id: tecnicoId };
    // Conversión explícita a Number para corregir ts(2345)
    this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), payload).subscribe({
      next: () => {
        this.snackBar.open('Técnico 1 actualizado correctamente', 'Cerrar', { duration: 3000 });
      },
      error: (err: any) => {
        console.error('Error al actualizar técnico 1:', err);
        this.snackBar.open('Error al actualizar técnico 1', 'Cerrar', { duration: 3000 });
      }
    });
  }

  //  Método de autoguardado para Técnico Asignado 2
  onTecnicoAsignado2Change(tecnicoId2: number | null): void {
    const payload = { tecnico_asignado_id_2: tecnicoId2 };
    // Conversión explícita a Number para corregir ts(2345)
    this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), payload).subscribe({
      next: () => {
        this.snackBar.open('Técnico 2 actualizado correctamente', 'Cerrar', { duration: 3000 });
      },
      error: (err: any) => {
        console.error('Error al actualizar técnico 2:', err);
        this.snackBar.open('Error al actualizar técnico 2', 'Cerrar', { duration: 3000 });
      }
    });
  }

  toggleAddRepuestoForm(subItemId: number) {
    this.showAddRepuestoForm[subItemId] = !this.showAddRepuestoForm[subItemId];
    if (this.showAddRepuestoForm[subItemId]) {
      // Reset form values
      this.selectedRepuesto = null;
      this.newRepuestoCantidad = 1;
    }
  }

  addRepuestoToItem(subItemId: number, activoFijo: any = null) {
    if (!this.selectedRepuesto || !this.newRepuestoCantidad) {
      console.log('Validación fallida: repuesto o cantidad no seleccionados');
      return;
    }

    // EXTRAEMOS LOS PRECIOS EXACTOS DEL CLIENTE
    const precioVentaFinal = this.getPrecioRepuestoCliente(this.selectedRepuesto, 'venta');
    const precioCompraFinal = this.getPrecioRepuestoCliente(this.selectedRepuesto, 'compra');

    // CREAMOS EL OBJETO CON EL VALOR CONGELADO
    const nuevoRepuestoGuardado = {
      cantidad: this.newRepuestoCantidad,
      id: this.selectedRepuesto?.id,
      repuesto: {
        id: this.selectedRepuesto?.id,
        familia: this.selectedRepuesto?.familia,
        articulo: this.selectedRepuesto?.articulo,
        marca: this.selectedRepuesto?.marca,
        codigoBarra: this.selectedRepuesto?.codigoBarra || '',
        precio_compra: precioCompraFinal,
        precio_venta: precioVentaFinal,
        valor_uf: this.selectedRepuesto?.valor_uf || false,
        clima: this.selectedRepuesto?.clima || false,
      },
    };

    if (this.checklistResponse) {
      if (this.checklistResponse.is_climate) {
        this.checklistResponse.climate_data.forEach((currentActivoFijo: any) => {
          if (activoFijo && activoFijo.activo_fijo_id === currentActivoFijo.activo_fijo_id) {
            currentActivoFijo.checklist.forEach((lista: any) => {
              lista.items.forEach((item: any) => {
                item.subItems.forEach((subItem: any) => {
                  if (subItem.id === subItemId) {
                    if (!subItem.repuestos) subItem.repuestos = [];
                    const hasCurrentRepuesto = subItem.repuestos.findIndex((r: any) => r.id === this.selectedRepuesto?.id);
                    if (hasCurrentRepuesto !== -1) {
                      subItem.repuestos[hasCurrentRepuesto].cantidad += this.newRepuestoCantidad;
                    } else {
                      subItem.repuestos.push(nuevoRepuestoGuardado);
                    }
                  }
                });
              });
            });
          }
        });
      } else {
        this.checklistResponse.data_normal.forEach((activo: any) => {
          // FIX: Filtrar por activo_fijo_id para evitar agregar el repuesto a todos los activos fijos de data_normal
          if (activoFijo && activo.activo_fijo_id != null && Number(activo.activo_fijo_id) !== Number(activoFijo.activo_fijo_id)) {
            return;
          }
          (activo.checklist || []).forEach((lista: ChecklistCategoria) => {
            lista.items.forEach((item: ChecklistItem) => {
              item.subItems.forEach((subItem: SubItem) => {
                if (subItem.id === subItemId) {
                  if (!subItem.repuestos) subItem.repuestos = [];
                  const hasCurrentRepuesto = subItem.repuestos.findIndex((r: any) => r.id === this.selectedRepuesto?.id);
                  if (hasCurrentRepuesto !== -1) {
                    subItem.repuestos[hasCurrentRepuesto].cantidad += this.newRepuestoCantidad;
                  } else {
                    subItem.repuestos.push(nuevoRepuestoGuardado);
                  }
                }
              });
            });
          });
        });
      }
    }

    this.selectedRepuesto = null;
    this.newRepuestoCantidad = 1;
    this.showAddRepuestoForm[subItemId] = false;
    this.updateListaInspeccion();
    this.onSaveRepuestos();
    this.calcularTotalFinal();
    console.log('Repuesto agregado exitosamente con precios de cliente');
  }

  deleteRepuesto(subItemId: number, repuesto: any, activoFijo:any = null) {
    // Verificar si el repuesto tiene ID (es un repuesto existente)
    if (repuesto.id) {
      if (this.checklistResponse) {
        if (this.checklistResponse.is_climate) {
          // Para checklist de clima
          this.checklistResponse.climate_data.forEach(
            (currentActivoFijo: any) => {
              if (
                activoFijo.activo_fijo_id === currentActivoFijo.activo_fijo_id
              ) {
                currentActivoFijo.checklist.forEach((lista: any) => {
                  lista.items.forEach((item: any) => {
                    item.subItems.forEach((subItem: any) => {
                      if (subItem.id === subItemId && subItem.repuestos) {
                        subItem.repuestos = subItem.repuestos.filter(
                          (r: any) => r.id !== repuesto.id
                        );
                      }
                    });
                  });
                });
              }
            }
          );
        } else {
          // Para checklist normal
          this.checklistResponse.data_normal.forEach((activo: any) => {
            // FIX: Filtrar por activo_fijo_id para eliminar el repuesto únicamente del activo seleccionado
            if (activoFijo && activo.activo_fijo_id != null && Number(activo.activo_fijo_id) !== Number(activoFijo.activo_fijo_id)) {
              return;
            }
            (activo.checklist || []).forEach((lista: any) => {
              lista.items.forEach((item: any) => {
                item.subItems.forEach((subItem: any) => {
                  if (subItem.id === subItemId && subItem.repuestos) {
                    subItem.repuestos = subItem.repuestos.filter(
                      (r: any) => r.id !== repuesto.id
                    );
                  }
                });
              });
            });
          });
        }
      }
    } else {
      // Es un repuesto temporal, eliminarlo de temporaryRepuestos
      if (this.temporaryRepuestos[subItemId]) {
        this.temporaryRepuestos[subItemId] = this.temporaryRepuestos[
          subItemId
        ].filter(
          (tempRepuesto) =>
            tempRepuesto.repuesto.id !== repuesto.repuesto.id ||
            tempRepuesto.cantidad !== repuesto.cantidad
        );

        if (this.temporaryRepuestos[subItemId].length === 0) {
          delete this.temporaryRepuestos[subItemId];
        }

        // Eliminar el repuesto del checklistResponse
        if (this.checklistResponse) {
          if (this.checklistResponse.is_climate) {
            // Para checklist de clima
            this.checklistResponse.climate_data.forEach((activoFijo: any) => {
              activoFijo.checklist.forEach((lista: any) => {
                lista.items.forEach((item: any) => {
                  item.subItems.forEach((subItem: any) => {
                    if (subItem.id === subItemId && subItem.repuestos) {
                      subItem.repuestos = subItem.repuestos.filter(
                        (r: any) => r.repuesto.id !== repuesto.repuesto.id
                      );
                    }
                  });
                });
              });
            });
          } else {
            // Para checklist normal
            this.checklistResponse.data_normal.forEach((activo: any) => {
              (activo.checklist || []).forEach((lista: any) => {
                lista.items.forEach((item: any) => {
                  item.subItems.forEach((subItem: any) => {
                    if (subItem.id === subItemId && subItem.repuestos) {
                      subItem.repuestos = subItem.repuestos.filter(
                        (r: any) => r.repuesto.id !== repuesto.repuesto.id
                      );
                    }
                  });
                });
              });
            });
          }
        }
      }
    }

    // Recalcular el total final
    this.onSaveRepuestos();
    this.calcularTotalFinal();
  }

  isRepuestoPendingDelete(subItemId: number, repuesto: any): boolean {
    return (
      this.temporaryDeletedRepuestos[subItemId]?.some(
        (deletedRepuesto) => deletedRepuesto.id === repuesto.id
      ) || false
    );
  }

  calculateSubItemTotal(repuestos: any[]): number {
    if (!repuestos) return 0;
    return repuestos
      .filter((r) => r && r.repuesto) // Solo considerar repuestos válidos
      .reduce((total, repuesto) => {
        const cantidad = repuesto.cantidad || 0;
        const precio =
          repuesto.precio_venta ||
          repuesto.repuesto?.precio_venta ||
          repuesto.repuesto?.precio ||
          0;
        return total + cantidad * precio;
      }, 0);
  }

  calculateItemTotal(repuestos: any[]): number {
    return this.calculateSubItemTotal(repuestos);
  }
  isValidated(): boolean {
    return this.solicitud?.status?.toLowerCase().trim() === 'validada';
  }
  calculateFinalTotal(): number {
    let finalTotal = 0;

    // Sumar repuestos de inspección
    // this.checklistResponse.forEach((res: any) => {
    //  res.checklist.forEach((item: any) => {
    //   item.items.forEach((subItem: any) => {
    //     if (subItem.repuestos) {
    //       finalTotal += this.repuestosList.find(r => r.id === subItem.repuestos[0].repuesto.id)?.precio_venta || 0;
    //     }
    //   });

    //  });
    // });
    // this.listaInspeccion.forEach(lista => {
    //   lista.items.forEach((item: any) => {
    //     item.subItems.forEach((subItem: any) => {
    //       if (subItem.repuestos) {
    //         finalTotal += this.calculateSubItemTotal(subItem.repuestos);
    //       }
    //     });
    //   });
    // });

    // // Sumar repuestos de activos fijos
    // if (this.solicitud?.activoFijoRepuestos) {
    //   finalTotal += this.calculateTotalActivosFijos();
    // }

    return finalTotal;
  }

  getRepuestosPorItem(subItemId: number): any[] {
    // Obtener repuestos existentes que no estén marcados para eliminar
    const existingRepuestos = this.itemRepuestos.filter(
      (repuesto) => repuesto.itemId === subItemId
    );

    // Obtener repuestos temporales
    const tempRepuestos = this.temporaryRepuestos[subItemId] || [];

    // Combinar ambos arrays
    return [...existingRepuestos, ...tempRepuestos];
  }

  private updateListaInspeccion() {
    if (!this.listaInspeccion || !this.itemRepuestos) return;

    // Crear un mapa de fotos por itemId
    const fotosPorItem: { [key: number]: string[] } = {};
    if (this.solicitud?.itemFotos) {
      this.solicitud.itemFotos.forEach((itemFoto: any) => {
        fotosPorItem[itemFoto.itemId] = itemFoto.fotos || [];
      });
    }

    this.listaInspeccion = this.listaInspeccion.map((lista) => ({
      ...lista,
      items: lista.items.map((item: any) => ({
        ...item,
        subItems: item.subItems.map((subItem: any) => {
          // Obtener repuestos existentes
          const existingRepuestos = this.itemRepuestos.filter(
            (repuesto) => repuesto.itemId === subItem.id
          );

          // Obtener repuestos temporales
          const tempRepuestos = this.temporaryRepuestos[subItem.id] || [];

          // Combinar repuestos existentes y temporales
          const allRepuestos = [...existingRepuestos, ...tempRepuestos].map(
            (repuesto) => ({
              ...repuesto,
              pendingDelete:
                this.temporaryDeletedRepuestos[subItem.id]?.some(
                  (deletedRepuesto) => deletedRepuesto.id === repuesto.id
                ) || repuesto.pendingDelete,
            })
          );

          // Verificar si hay fotos asociadas a este subItem
          const fotosDelItem = fotosPorItem[subItem.id] || [];

          return {
            ...subItem,
            estado: subItem.estado,
            fotos: fotosDelItem.length > 0 ? fotosDelItem : [],
            repuestos: allRepuestos,
          };
        }),
      })),
    }));

    console.log('Lista actualizada con fotos:', this.listaInspeccion);
  }

  getItemEstado(itemId: number) {
    return this.solicitud?.itemEstados?.find(
      (estado: any) => estado.itemId === itemId
    );
  }

  getEstadoLabel(estado: string | undefined): string {
    if (!estado) return 'Sin Estado';

    const estados = {
      conforme: 'Conforme',
      no_conforme: 'No Conforme',
      no_aplica: 'No Aplica',
      pendiente: 'Pendiente',
    };

    return estados[estado as keyof typeof estados] || estado;
  }

  getEstadoClass(estado: string | null): string {
    if (!estado) return '';

    switch (estado.toLowerCase()) {
      case 'conforme':
        return 'badge-success';
      case 'no_aplica':
        return 'badge-warning';
      case 'no_conforme':
        return 'badge-danger';
      default:
        return '';
    }
  }

  getItemFotos(itemId: number) {
    return this.solicitud?.itemFotos?.find(
      (item: any) => item.itemId === itemId
    );
  }

  async saveChanges() {
    try {
      // Preparar los datos para guardar
      const changes = {
        addedRepuestos: Object.entries(this.temporaryRepuestos).flatMap(
          ([itemId, repuestos]) =>
            repuestos
              .filter((r) => !r.pendingDelete)
              .map((r) => ({
                itemId: parseInt(itemId),
                repuestoId: r.repuesto.id,
                cantidad: r.cantidad,
                solicitarVisitaId: Number(this.solicitudId),
                comentario: r.comentario || '',
                garantia: r.garantia || 'no',
                turno: r.turno || 'diurno',
                estado_solicitud: r.estado_solicitud || 'resuelto',
              }))
        ),
        deletedRepuestos: Object.values(this.temporaryDeletedRepuestos)
          .flat()
          .map((r) => r.id),
      };

      // Guardar los cambios
      await this.solicitarVisitaService
        .updateRepuestos(this.solicitudId, changes)
        .toPromise();

      // Limpiar los temporales
      this.temporaryRepuestos = {};
      this.temporaryDeletedRepuestos = {};

      // Recargar la solicitud
      this.loadSolicitud();

      this.snackBar.open('Cambios guardados correctamente', 'Cerrar', {
        duration: 3000,
      });
    } catch (error) {
      console.error('Error al guardar los cambios:', error);
      this.snackBar.open('Error al guardar los cambios', 'Cerrar', {
        duration: 3000,
      });
    }
  }

  hasChanges(): boolean {
    // return (
    //   Object.values(this.temporaryRepuestos).some(
    //     (repuestos) => repuestos.length > 0
    //   ) ||
    //   Object.values(this.temporaryDeletedRepuestos).some(
    //     (repuestos) => repuestos.length > 0
    //   )
    // );
    return (
      Object.values(this.temporaryRepuestos).some(
        (repuestos) => repuestos.length > 0
      ) ||
      Object.values(this.temporaryDeletedRepuestos).some(
        (repuestos) => repuestos.length > 0
      ) ||
      JSON.stringify(this.temporalChecklist) !== JSON.stringify(this.checklistResponse)
    );
  }

  private initMap(): void {
    const mapElement = document.getElementById('map');
    // Si el elemento del mapa no está en el DOM, no hacer nada.
    if (!mapElement) {
      return;
    }

    if (!this.map) {
      const mapElement = document.getElementById('map');
      if (!mapElement) {
        console.error('Elemento del mapa no encontrado');
        return;
      }

      try {
        // Configurar el ícono por defecto de Leaflet
        const iconRetinaUrl = 'assets/marker-icon-2x.png';
        const iconUrl = 'assets/marker-icon.png';
        const shadowUrl = 'assets/marker-shadow.png';

        const iconDefault = L.icon({
          iconRetinaUrl,
          iconUrl,
          shadowUrl,
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          tooltipAnchor: [16, -28],
          shadowSize: [41, 41],
        });
        L.Marker.prototype.options.icon = iconDefault;

        // Inicializar el mapa en Santiago de Chile por defecto
        this.map = L.map('map', {
          center: [-33.4569, -70.6483],
          zoom: 13,
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 18,
          minZoom: 3,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(this.map);

        // Usar latitud y longitud del móvil si están disponibles
        if (this.solicitud?.latitud_movil && this.solicitud?.longitud_movil) {
          const lat = parseFloat(this.solicitud.latitud_movil);
          const lng = parseFloat(this.solicitud.longitud_movil);

          if (!isNaN(lat) && !isNaN(lng)) {
            const marker = L.marker([lat, lng]).bindPopup(`
                <b>${this.solicitud.local?.nombre_local || 'Local'}</b><br>
                ${this.solicitud.local?.direccion || ''}<br>
                ${this.solicitud.local?.comuna || ''}<br>
                <strong>Ubicación del técnico</strong><br>
                <img src="assets/images/empresas/wazee.png" 
                     onclick="window.open('https://waze.com/ul?ll=${lat},${lng}&navigate=yes', '_blank')"
                     style="cursor:pointer; width: 24px; height: 24px;">
                Abrir en Waze
              `);

            marker.addTo(this.map);
            this.map.setView([lat, lng], 15);
          }
        }
        // Si no hay coordenadas del móvil, usar las del local
        else if (
          this.solicitud?.local?.latitud &&
          this.solicitud?.local?.longitud
        ) {
          const lat = parseFloat(this.solicitud.local.latitud);
          const lng = parseFloat(this.solicitud.local.longitud);

          if (!isNaN(lat) && !isNaN(lng)) {
            const marker = L.marker([lat, lng]).bindPopup(`
                <b>${this.solicitud.local?.nombre_local || 'Local'}</b><br>
                ${this.solicitud.local?.direccion || ''}<br>
                ${this.solicitud.local?.comuna || ''}<br>
                <img src="assets/images/empresas/wazee.png" 
                     onclick="window.open('https://waze.com/ul?ll=${lat},${lng}&navigate=yes', '_blank')"
                     style="cursor:pointer; width: 24px; height: 24px;">
                Abrir en Waze
              `);

            marker.addTo(this.map);
            this.map.setView([lat, lng], 15);
          }
        }

        // Invalidar el tamaño del mapa para forzar su redibujado
        setTimeout(() => {
          this.map?.invalidateSize();
        }, 200);
      } catch (error) {
        console.error('Error al inicializar el mapa:', error);
      }
    }
  }

  // Método para guardar los cambios
  async onSubmit() {
    if (this.solicitudForm.invalid) {
      return;
    }

    const formData = this.solicitudForm.getRawValue();
    console.log('Form data before update:', formData); // Debug log

    const updateData = {
      especialidad: formData.especialidad,
      ticketGruman: formData.ticketGruman,
      observaciones: formData.observaciones,
      longitud_movil: formData.longitud_movil,
      latitud_movil: formData.latitud_movil,
      valorPorLocal: formData.valorPorLocal,
      registroVisita: formData.registroVisita,
      causaRaizId: formData.causaRaizId || null,
      listaInspeccion: this.listaInspeccion,
      image_ot: this.otImages.length > 0 ? this.otImages[0] : '',
      image_ot_extra: this.otImages.length > 1 ? this.otImages.slice(1).join(',') : '',
    };

    console.log('Update data being sent:', updateData); // Debug log

    try {
      await this.solicitarVisitaService
        .updateSolicitudVisita(Number(this.solicitudId), updateData)
        .toPromise();
      this.snackBar.open('Solicitud actualizada correctamente', 'Cerrar', {
        duration: 3000,
      });
      this.router.navigate(['/transacciones/solicitudes-de-visita']);
    } catch (error) {
      console.error('Error al actualizar la solicitud:', error);
      this.snackBar.open('Error al actualizar la solicitud', 'Cerrar', {
        duration: 3000,
      });
    }
  }

  cargarTecnicos() {
    this.usersService.getAllTecnicos().subscribe({
      next: (response: Tecnico[]) => {
        this.tecnicos = response;
        console.log('Técnicos cargados:', this.tecnicos);
      },
      error: (error: any) => {
        console.error('Error cargando técnicos:', error);
      },
    });
  }

  /**
   * Deshabilita todos los controles del formulario cuando la solicitud está rechazada
   */
  private deshabilitarControlesFormulario(): void {
    // Deshabilitar todos los controles excepto los especiales
    Object.keys(this.solicitudForm.controls).forEach((key) => {
      // Si es readonly, bloquea el campo y pasa al siguiente
      if (this.isReadOnly) {
        this.solicitudForm.get(key)?.disable();
        return;
      }
      // Solo permitir editar observaciones siempre
      // Para valorPorLocal, permitir edición solo si es pendiente, reabierta o finalizada,
      // pero nunca si está rechazada, aprobada o validada
      // Para registroVisita, permitir edición solo si es finalizada o reabierta
      // pero debe estar deshabilitado si es validada (aunque visible)
      const control = this.solicitudForm.get(key);

      // Regla 1: Observaciones siempre editables
      if (key === 'observaciones' || key === 'comentario_general') {
        control?.enable();
        return;
      }

      // Regla 2a: Fechas de Servicio (Solo cuando ya terminó)
      if (key === 'fecha_hora_inicio_servicio' || key === 'fecha_hora_fin_servicio') {
        if ((this.solicitud?.status === 'finalizada' || this.isReabierta || this.solicitud?.status === 'reabierta') && !this.isRechazada && !this.isValidada) {
          control?.enable(); 
        } else {
          control?.disable();
        }
        return;
      }

      // Regla 2b: Fecha de Visita (Habilitada en Pendiente, Proceso, Reabierta o si Gruman la va a Programar)
      if (key === 'fechaVisita') {
        if (this.isPendiente || this.isAtendidaEnProceso || this.isReabierta || (this.isAprobada && this.esGruman)) {
          control?.enable();
        } else {
          control?.disable();
        }
        return;
      }

      // Regla 2c: Técnicos (Habilitada en Pendiente, Proceso o si Gruman la va a Programar)
      if (key === 'tecnico_asignado_id' || key === 'sectorTrabajoId' || key === 'especialidad') {
        if (this.isPendiente || this.isAtendidaEnProceso || (this.isAprobada && this.esGruman)) {
          control?.enable();
        } else {
          control?.disable();
        }
        return;
      }

      // CR-202610-0004 - Permitir editar el técnico acompañante (técnico 2) en estado de validación
      if (key === 'tecnico_asignado_id_2') {
        if (this.isPendiente || this.isAtendidaEnProceso || (this.isAprobada && this.esGruman) || this.solicitud?.status === 'finalizada' || this.isReabierta || this.solicitud?.status === 'reabierta') {
          control?.enable();
        } else {
          control?.disable();
        }
        return;
      }

      // Regla 3: Valor por local (NO deshabilitarlo si es Gruman y está Aprobada)
      if (key === 'valorPorLocal') {
        if (
           (this.isPendiente ||
            this.isReabierta ||
            this.solicitud?.status === 'reabierta' ||
            this.solicitud?.status === 'finalizada' ||
            (this.isAprobada && this.esGruman)) && // <--- Gruman puede editar el valor si está Aprobada
          !this.isRechazada &&
          !this.isValidada
        ) {
          control?.enable();
        } else {
          control?.disable();
        }
        return;
      }

      // Regla 4: Registro de Visita
      if (key === 'registroVisita') {
        if (
          (this.solicitud?.status === 'finalizada' ||
            this.solicitud?.status === 'reabierta' ||
            this.isReabierta) &&
          !this.isValidada &&
          this.solicitud?.status !== 'validada'
        ) {
          control?.enable();
        } else {
          control?.disable();
        }
        return;
      }
      
      // Si no es ninguno de los campos especiales de arriba, se bloquea por seguridad
      control?.disable();
    });

    const estadoActual = this.solicitud?.status?.toLowerCase();

    if (!this.isReadOnly && estadoActual !== 'validada' && estadoActual !== 'rechazada') {
        this.solicitudForm.get('facturacion_id')?.enable({ emitEvent: false });
      } else {
        this.solicitudForm.get('facturacion_id')?.disable({ emitEvent: false });
      }
  }

  // Método para calcular el total general
  calculateTotal(): number {
    if (!this.listaInspeccion) return 0;

    return this.listaInspeccion.reduce((totalItems, item) => {
      if (!item.items) return totalItems;

      const subItemsTotal = item.items.reduce(
        (totalSubItems: number, subItem: any) => {
          if (!subItem.repuestos) return totalSubItems;

          // Filtramos repuestos válidos (no nulos) y no marcados para eliminar
          const validRepuestos = subItem.repuestos.filter(
            (rep: any) =>
              rep.repuesto && !this.isRepuestoPendingDelete(subItem.id, rep)
          );

          const subItemTotal = validRepuestos.reduce(
            (total: number, repuesto: any) => {
              const precio = repuesto.repuesto?.precio || 0;
              const cantidad = repuesto.cantidad || 0;
              return total + precio * cantidad;
            },
            0
          );

          return totalSubItems + subItemTotal;
        },
        0
      );

      return totalItems + subItemsTotal;
    }, 0);
  }

  private loadEspecialidades(): void {
    this.especialidadesService.findAll().subscribe({
      next: (data: any[]) => {
        this.especialidades = data;
        
        // Ya no necesitamos forzar un patchValue a Número aquí porque el valor es un string
      },
      error: (error: any) => {
        console.error('Error cargando especialidades:', error);
      },
    });
  }

  getEspecialidadNombre(especialidadId: string | null): string {
    if (!especialidadId) return 'Sin especialidad';

    const especialidad = this.especialidades.find(
      (e) => e.id === Number(especialidadId)
    );
    return especialidad ? especialidad.nombre : 'Sin especialidad';
  }

  getTipoServicioNombre(tipoServicioId: number | null): string {
    if (!tipoServicioId) return 'Sin tipo de servicio';
    const tipo = this.tiposServicio.find((t) => t.id === tipoServicioId);
    return tipo ? tipo.nombre : 'Sin tipo de servicio';
  }

  getSectorTrabajoNombre(sectorTrabajoId: number | null): string {
    if (!sectorTrabajoId) return 'Sin sector de trabajo';
    const sector = this.sectoresTrabajos.find((s) => s.id === sectorTrabajoId);
    return sector ? sector.nombre : 'Sin sector de trabajo';
  }

  // Método para verificar si el técnico tiene la especialidad requerida
  tecnicoTieneEspecialidad(tecnico: any): boolean {
    if (!this.solicitud?.especialidad) return false;
    const especialidadId = Number(this.solicitud.especialidad);
    return tecnico.especialidades?.some(
      (esp: any) => esp.id === especialidadId
    );
  }

  // Opcional: Agregar un método para obtener el nombre de las especialidades del técnico
  getTecnicoEspecialidades(tecnico: Tecnico): string {
    return (
      tecnico.especialidades?.map((esp) => esp.nombre).join(', ') ||
      'Sin especialidades'
    );
  }

  private watchEspecialidadChanges() {
    this.solicitudForm
      .get('especialidad')
      ?.valueChanges.subscribe((newValue: any) => {
        // Actualizar la especialidad en la solicitud manteniendo el tipo numérico puro
        if (this.solicitud) {
          this.solicitud.especialidad = newValue ? Number(newValue) : null; //  FIX: Forzar a número puro
        }
      });
  }

  // Watch for changes in the tipo servicio field to update the label
  private watchTipoServicioChanges() {
    this.solicitudForm.get('tipoServicioId')?.valueChanges.subscribe(() => {
      // Trigger change detection to update the label
      this.cd.detectChanges();
    });
  }

  // Add method to filter available technicians for second select
  getTecnicosDisponiblesParaSegundoSelect(): any[] {
    const tecnico1Id = this.solicitudForm.get('tecnico_asignado_id')?.value;
    return this.tecnicos.filter((tecnico) => tecnico.id !== tecnico1Id);
  }

  private loadCausasRaiz(): void {
    this.causaRaizService.findAll().subscribe({
      next: (data: any[]) => {
        this.causasRaiz = data;
      },
      error: (error: any) => {
        console.error('Error cargando causas raíz:', error);
        this.snackBar.open('Error al cargar las causas raíz', 'Cerrar', {
          duration: 3000,
        });
      },
    });
  }

  getEstadoOperativoLabel(estado: string): string {
    const labels: Record<string, string> = {
      funcionando: 'Funcionando',
      detenido: 'Detenido',
      funcionando_con_observaciones: 'Funcionando con observaciones',
    };
    return labels[estado] || '';
  }

  getEstadoOperativoClass(estado: string): string {
    const classes: Record<string, string> = {
      funcionando: 'text-success',
      detenido: 'text-danger',
      funcionando_con_observaciones: 'text-warning',
    };
    return classes[estado] || '';
  }

  calculateActivoFijoRepuestoTotal(detallesRepuestos: any[]): number {
    return (
      detallesRepuestos?.reduce(
        (sum: number, detalle: any) =>
          sum + detalle.cantidad * detalle.precio_unitario,
        0
      ) || 0
    );
  }

  calculateTotalActivosFijos(): number {
    if (!this.solicitud?.activoFijoRepuestos) return 0;

    return this.solicitud.activoFijoRepuestos.reduce(
      (total: number, activoFijo: any) => {
        return (
          total +
          this.calculateActivoFijoRepuestoTotal(activoFijo.detallesRepuestos)
        );
      },
      0
    );
  }

  getActivoFijoInfo(activoFijoId: number | string): string {
    const activoFijo = this.solicitud?.local?.activoFijoLocales?.find(
      (af: any) => af.id?.toString() === activoFijoId?.toString()
    );
    if (activoFijo) {
      return `${activoFijo.tipo_equipo} - ${activoFijo.marca} (${activoFijo.codigo_activo})`;
    }
    return 'No encontrado';
  }

  getResponsesChecklist(activoFijoId: number): any {
    const activoFijo = this.solicitud?.local?.listaInspeccion?.find(
      (af: any) => af.id === activoFijoId
    );
    if (activoFijo) {
      return activoFijo;
    }
    return [];
  }

  /**
   * Obtiene los detalles de un Activo Fijo aplicando 3 niveles de resolución:
   * 1. Relación en la solicitud (solicitud.local.activoFijoLocales)
   * 2. Checklist de Clima (checklistResponse.climate_data)
   * 3. Consulta asíncrona al servicio Angular ActivoFijoLocalService (Caché en memoria)
   */
  getActivoFijoDetails(activoFijoId: number | string): any {
    if (!activoFijoId) return this.getActivoFijoFallback();

    const targetId = String(activoFijoId).trim();

    // Si ya fue resuelto previamente y guardado en la caché en memoria, lo retornamos directo
    if (this.mapaActivosCache[targetId]) {
      return this.mapaActivosCache[targetId];
    }

    // 1. MEDIDA 1: Intentar buscar en la relación cargada del local de la solicitud
    const activoFijoLocal = this.solicitud?.local?.activoFijoLocales?.find(
      (af: any) => String(af.id).trim() === targetId
    );

    if (activoFijoLocal) {
      const result = {
        tipo_equipo: activoFijoLocal.tipo_equipo || 'No especificado',
        marca: activoFijoLocal.marca || 'No especificada',
        codigo_activo: activoFijoLocal.codigo_activo || 'No especificado',
        potencia_equipo: activoFijoLocal.potencia_equipo || 'No especificada',
        refrigerante: activoFijoLocal.refrigerante || 'No especificado',
        on_off_inverter: activoFijoLocal.on_off_inverter || 'No especificado',
        suministra: activoFijoLocal.suministra || 'No especificado',
      };
      this.mapaActivosCache[targetId] = result;
      return result;
    }

    // 2. MEDIDA 2: Fallback dentro de climate_data
    const climateItem = this.checklistResponse?.climate_data?.find(
      (cd: any) => String(cd.activo_fijo_id).trim() === targetId
    );

    if (climateItem?.detailActivoFijo && climateItem.detailActivoFijo.marca !== 'No encontrado' && climateItem.detailActivoFijo.codigo_activo !== 'No encontrado') {
      this.mapaActivosCache[targetId] = climateItem.detailActivoFijo;
      return climateItem.detailActivoFijo;
    }

    // 3. MEDIDA 3: Búsqueda asíncrona mediante ActivoFijoLocalService
    // Para evitar múltiples peticiones simultáneas del mismo ID, marcamos temporalmente en la caché
    this.mapaActivosCache[targetId] = this.getActivoFijoLoadingFallback();

    this.activoFijoLocalService.getById(Number(targetId)).pipe(
      catchError((error: any) => {
        console.warn(`[ActivoFijoLocalService] No se encontró el activo con ID ${targetId}:`, error);
        return of(null);
      })
    ).subscribe((res: any) => {
      if (res) {
        const activoResuelto = {
          tipo_equipo: res.tipo_equipo || 'No especificado',
          marca: res.marca || 'No especificada',
          codigo_activo: res.codigo_activo || 'No especificado',
          potencia_equipo: res.potencia_equipo || 'No especificada',
          refrigerante: res.refrigerante || 'No especificado',
          on_off_inverter: res.on_off_inverter || 'No especificado',
          suministra: res.suministra || 'No especificado',
        };
        // Guardamos en la caché de la clase y forzamos refresco de plantilla
        this.mapaActivosCache[targetId] = activoResuelto;
        this.cd.detectChanges();
      } else {
        this.mapaActivosCache[targetId] = this.getActivoFijoFallback();
      }
    });

    return this.mapaActivosCache[targetId];
  }

  // Helper con estado 'Cargando...' mientras responde la API
  private getActivoFijoLoadingFallback(): any {
    return {
      tipo_equipo: 'Cargando...',
      marca: 'Cargando...',
      codigo_activo: 'Cargando...',
      potencia_equipo: '-',
      refrigerante: '-',
      on_off_inverter: '-',
      suministra: '-',
    };
  }

  // Helper con valores por defecto
  private getActivoFijoFallback(): any {
    return {
      tipo_equipo: 'No especificado',
      marca: 'No especificada',
      codigo_activo: 'Sin Código',
      potencia_equipo: '-',
      refrigerante: '-',
      on_off_inverter: '-',
      suministra: '-',
    };
  }

  isTemporaryRepuesto(subItemId: number, repuesto: any): boolean {
    return (
      this.temporaryRepuestos[subItemId]?.some(
        (tempRepuesto: any) =>
          tempRepuesto.id === repuesto.id &&
          tempRepuesto.repuesto.id === repuesto.repuesto.id &&
          tempRepuesto.cantidad === repuesto.cantidad
      ) || false
    );
  }

  hasTemporaryRepuestos(): boolean {
    // Check if there are any temporary repuestos
    return Object.values(this.temporaryRepuestos).some(
      (repuestos) => repuestos && repuestos.length > 0
    );
  }

  cambiarFechaVisita(): void {
    if (this.nuevaFechaVisita) {
      this.solicitarVisitaService
        .updateSolicitudVisita(Number(this.solicitudId), {
          fechaVisita: this.nuevaFechaVisita,
        })
        .subscribe({
          next: () => {
            Swal.fire({
              title: 'Éxito',
              text: 'Fecha de visita actualizada correctamente',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              // Redirigir a la lista de solicitudes aprobadas
              this.router.navigate([
                '/transacciones/solicitudes-de-visita/aprobadas',
              ]);
            });
          },
          error: (error: any) => {
            console.error('Error al actualizar la fecha:', error);
            Swal.fire({
              title: 'Error',
              text: 'No se pudo actualizar la fecha de visita',
              icon: 'error',
            });
          },
        });
    }
  }

  async downloadPhotos(imageUrls: string[]): Promise<void> {
    if (!imageUrls || imageUrls.length === 0) {
      Swal.fire({
        title: 'Error',
        text: 'No hay fotos disponibles para descargar',
        icon: 'error',
      });
      return;
    }

    try {
      // Mostrar indicador de progreso
      Swal.fire({
        title: 'Preparando descarga',
        text: 'Por favor espere...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Descargar cada imagen
      for (let i = 0; i < imageUrls.length; i++) {
        const url = imageUrls[i];
        const response = await fetch(url);
        const blob = await response.blob();

        // Crear un nombre de archivo basado en la fecha y un contador
        const fileName = `foto_${new Date().toISOString().split('T')[0]}_${
          i + 1
        }.jpg`;

        // Crear un elemento <a> para descargar
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;

        // Agregar al DOM, hacer clic y remover
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Esperar un poco entre descargas para evitar bloqueos del navegador
        await new Promise((resolve) => setTimeout(resolve, 500));
      }

      // Mostrar mensaje de éxito
      Swal.fire({
        title: 'Éxito',
        text: `Se han descargado ${imageUrls.length} foto(s)`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error('Error al descargar las fotos:', error);
      Swal.fire({
        title: 'Error',
        text: 'Hubo un error al descargar las fotos',
        icon: 'error',
      });
    }
  }

  private async actualizarImagenesEnBD() {
    // La primera foto va al campo principal (APK compatible)
    const principal = this.otImages.length > 0 ? this.otImages[0] : '';
    
    // El resto va al campo extra separado por comas
    const extras = this.otImages.length > 1 ? this.otImages.slice(1).join(',') : '';

    const payload = {
      image_ot: principal,
      image_ot_extra: extras
    };

    this.solicitudForm.patchValue(payload);
    
    return this.solicitarVisitaService.updateSolicitudVisita(
      Number(this.solicitudId), 
      payload
    ).toPromise();
  }

// 🔥 NUEVA SUBIDA MÚLTIPLE
  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.isUploadingOT = true;
      
      Swal.fire({
        title: 'Subiendo imágenes...',
        text: 'Por favor espere mientras procesamos los archivos.',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      try {
        for (let i = 0; i < input.files.length; i++) {
          const file = input.files[i];
          const imageUrl = await this.uploadSingleOTImage(file);
          if (imageUrl) {
            this.otImages.push(imageUrl);
          }
        }

        // Repartir y guardar en BD
        await this.actualizarImagenesEnBD();
        
        this.cd.detectChanges();
        Swal.fire({ icon: 'success', title: 'Imágenes subidas exitosamente', timer: 2000, showConfirmButton: false });
        
      } catch (error) {
        console.error('Error al subir imágenes de OT:', error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Algunas imágenes no se pudieron subir' });
      } finally {
        this.isUploadingOT = false;
        if (input) input.value = ''; 
      }
    }
  }

  // Procesador individual con tu compatibilidad de URL
  private async uploadSingleOTImage(file: File): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target?.result as string;
        img.onload = async () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // CR-202609-0006 Se aumenta el límite de dimensión a Full HD para mejorar la resolución
          const MAX_WIDTH = 1920;
          const MAX_HEIGHT = 1080;
          let width = img.width; let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) { height *= MAX_WIDTH / width; width = MAX_WIDTH; }
          } else {
            if (height > MAX_HEIGHT) { width *= MAX_HEIGHT / height; height = MAX_HEIGHT; }
          }

          canvas.width = width; canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob(async (blob) => {
            if (!blob) return reject('Error al comprimir');
            
            const formData = new FormData();
            formData.append('file', new File([blob], `${Date.now()}_${file.name}`, { type: 'image/jpeg' }));
            
            try {
              const response = await this.uploadDataService.uploadFileFirebase(formData, `?path=solicitudes-visita/${this.solicitudId}/ot`).toPromise();
              if (response && response.url) {
                // Aquí mantenemos tu validación de servidor local vs HTTP
                resolve(response.url.startsWith('http') ? response.url : `${environment.apiUrl}/${response.url}`);
              } else {
                reject('No URL received');
              }
            } catch (err) { reject(err); }
          }, 'image/jpeg',
          //  CR-202609-0006 Se incrementa la calidad del JPEG a 0.88 para conservar nitidez y detalles
              0.88);
        };
      };
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  }

  async eliminarImagenOT(index: number): Promise<void> {
    //  Confirmación antes de eliminar foto adjunta
    const confirmacion = await Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar la imagen adjunta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (confirmacion.isConfirmed) {
      try {
        this.otImages.splice(index, 1);
        
        await this.actualizarImagenesEnBD();
        
        this.cd.detectChanges();
        this.snackBar.open('Imagen eliminada correctamente', 'Cerrar', { duration: 3000 });
      } catch (error) {
        console.error('Error al eliminar la imagen:', error);
        this.snackBar.open('Error al eliminar la imagen', 'Cerrar', { duration: 3000 });
      }
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.onFileSelected({ target: { files: files } } as unknown as Event);
    }
  }

  /**
   * Asigna el imagePreview cuando existe image_ot en el registro
   * @param image_ot La imagen en formato base64
   */
  private setImagePreview(image_ot: string): void {
    this.imagePreview = image_ot;
    this.urlImage = image_ot;
  }


  agregarRepuesto(subItem: any, activoId: number | null = null) {
    const dialogRef = this.dialog.open(AgregarRepuestoComponent, {
      width: '500px',
      data: { subItem },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // Agregar el nuevo repuesto a la lista
        this.selectedRepuesto = result.repuesto;
        this.newRepuestoCantidad = result.cantidad;
        const activoFijoFound = activoId ? this.findActivoFijoByActivoId(activoId) : null;
        this.addRepuestoToItem(subItem, activoFijoFound);
        this.calcularTotalFinal();
      }
    });
  }

  editarRepuesto(subItemId: number, repuesto: any, activoId: number | null = null) {
    const dialogRef = this.dialog.open(AgregarRepuestoComponent, {
      width: '500px',
      data: {
        repuesto,
        modoEdicion: true,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // Actualizar el repuesto existente
        console.log('EDITANDO', result);
        const activoFijoFound = activoId ? this.findActivoFijoByActivoId(activoId) : null;
        this.deleteRepuesto(subItemId, repuesto, activoFijoFound);
        this.selectedRepuesto = result.repuesto;
        this.newRepuestoCantidad = result.cantidad;
        this.addRepuestoToItem(subItemId, activoFijoFound);
      }
    });
  }

  eliminarRepuesto(subItemId: number, repuesto: any, activoId: number | null = null) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Eliminar Repuesto',
        message: '¿Está seguro que desea eliminar este repuesto?',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // Eliminar el repuesto de la lista
        const activoFijoFound = activoId ? this.findActivoFijoByActivoId(activoId) : null;
        this.deleteRepuesto(subItemId, repuesto, activoFijoFound);
      }
    });
  }

  calcularTotalFinal() {
    let total = 0;

    if (this.checklistResponse.is_climate) {
      this.checklistResponse.climate_data.forEach((activoFijo: any) => {

        activoFijo.checklist.forEach((lista: any) => {
          lista.items.forEach((item: any) => {
            item.subItems.forEach((subItem: any) => {
              subItem.repuestos.forEach((repuesto: any) => {

                total += repuesto.repuesto.precio_venta * repuesto.cantidad;
              });
            });
          });
        });
      });
    } else {
      this.checklistResponse?.data_normal?.forEach((lista: any) => {
        lista.checklist.forEach((item: any) => {
          item.items.forEach((subItem: any) => {
            subItem.subItems.forEach((subSubItem: any) => {
              subSubItem.repuestos.forEach((repuesto: any) => {
                total += repuesto.repuesto.precio_venta * repuesto.cantidad;
              });
            });
          });
        });
      });
    }
    this.checklistResponse.total_final = total;
  }

  loadTiposSolicitud(clienteId: number) {
    this.tipoSolicitudService.findByClienteId(clienteId).then((tipos: any) => {
      this.tiposSolicitud = tipos || [];
    }).catch((error: any) => {
      console.error('Error cargando tipos de solicitud:', error);
    });
  }

  getTipoSolicitudNombre(id: number): string {
    const tipoSolicitud = this.tiposSolicitud.find(tipo => tipo.id === id);
    return tipoSolicitud ? `${tipoSolicitud.nombre.toUpperCase()} - Día(s): ${tipoSolicitud.sla_dias} / Hora(s): ${tipoSolicitud.sla_hora}` : 'No especificado';
  }

  // Función para actualizar observaciones en checklistResponse con debounce
  actualizarObservacionesEnChecklist(subItemId: number, observaciones: string, activoId: number | null = null) {
    // Emitir al Subject para que sea procesado con debounce
    const activoFijoFound = activoId ? this.findActivoFijoByActivoId(activoId) : null;
    this.observacionesSubject.next({ subItemId, observaciones, activoFijo: activoFijoFound });
  }

  /**
   * Encuentra el activo fijo correcto basado en el activoId
   */
  private findActivoFijoByActivoId(activoId: number | string): any {
    // Se añade soporte para resolver el activo en data_normal además de climate_data
    if (!this.checklistResponse) return null;

    if (this.checklistResponse.is_climate && this.checklistResponse.climate_data) {
      return this.checklistResponse.climate_data.find((activo: any) => 
        activo.activo_fijo_id?.toString() === activoId?.toString()
      );
    }

    if (!this.checklistResponse.is_climate && this.checklistResponse.data_normal) {
      return this.checklistResponse.data_normal.find((activo: any) => 
        activo.activo_fijo_id?.toString() === activoId?.toString()
      );
    }

    return null;
  }

  // Función interna que realiza la actualización real
  private actualizarObservacionesEnChecklistInterno(subItemId: number, observaciones: string, activoFijo: any = null) {
    if (!this.checklistResponse) {
      return;
    }

    // Sanitizar el ID soportando tanto el objeto completo como la primitiva enviada desde la vista
    const targetActivoId = typeof activoFijo === 'object' ? activoFijo?.activo_fijo_id : activoFijo;

    if (this.checklistResponse.is_climate && targetActivoId) {
      // Para checklist de clima
      this.checklistResponse.climate_data.forEach((currentActivoFijo: any) => {
        // Normalización numérica para evitar desacoples de tipo string/number
        if (Number(currentActivoFijo.activo_fijo_id) === Number(targetActivoId)) {
          currentActivoFijo.checklist.forEach((lista: any) => {
            lista.items.forEach((item: any) => {
              item.subItems.forEach((subItem: any) => {
                if (subItem.id === subItemId) {
                  subItem.observaciones = observaciones;
                }
              });
            });
          });
        }
      });
    } else if (!this.checklistResponse.is_climate && targetActivoId) {
      // Para checklist normal acotado al activoFijo específico evitando sobreescritura masiva
      this.checklistResponse.data_normal.forEach((currentActivoNormal: any) => {
        // Normalización numérica para coincidencia exacta en data_normal
        if (Number(currentActivoNormal.activo_fijo_id) === Number(targetActivoId)) {
          (currentActivoNormal.checklist || []).forEach((lista: any) => {
            lista.items.forEach((item: any) => {
              item.subItems.forEach((subItem: any) => {
                if (subItem.id === subItemId) {
                  subItem.observaciones = observaciones;
                }
              });
            });
          });
        }
      });
    } else {
      // Fallback para checklist normal si no viene activoFijo
      if (this.checklistResponse.data_normal && this.checklistResponse.data_normal.length) {
        this.checklistResponse.data_normal.forEach((activo: any) => {
          (activo.checklist || []).forEach((lista: any) => {
            lista.items.forEach((item: any) => {
              item.subItems.forEach((subItem: any) => {
                if (subItem.id === subItemId) {
                  subItem.observaciones = observaciones;
                }
              });
            });
          });
        });
      }
    }

    this.solicitarVisitaService
      .updateChecklistVisita(Number(this.solicitudId), {
        is_climate: this.checklistResponse.is_climate,
        data: this.checklistResponse,
      })
      .subscribe((res: any) => {
        console.log('RESPUESTA ENDPOINT', res);
        if (res.success) {
          this.snackBar.open('Comentario actualizado correctamente', 'Cerrar', {
            duration: 3000,
          });
        } else {
          this.snackBar.open('Error al guardar los comentarios', 'Cerrar', {
            duration: 3000,
          });
        }
      });

    console.log('Observaciones actualizadas en checklistResponse:', observaciones);
  }

  /**
   * Activa el input file para un subitem específico
   */
  triggerFileInput(subitemId: number, activoId?: number, index?: number): void {
    let inputId: string;
    
    if (activoId !== undefined && index !== undefined) {
      // Para checklist de clima: incluir activoId
      inputId = `fileInput-${subitemId}-${activoId}-${index}`;
    } else if (index !== undefined) {
      // Para checklist normal con índice
      inputId = `fileInput-${subitemId}-${index}`;
    } else {
      // Para checklist normal sin índice
      inputId = `fileInput-${subitemId}`;
    }
    
    console.log('triggerFileInput llamado con:', { subitemId, activoId, index, inputId });
    
    const fileInput = document.getElementById(inputId) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
      console.log('Input encontrado y clickeado:', inputId);
    } else {
      console.error(`No se encontró el input con ID: ${inputId}`);
    }
  }

  /**
   * Maneja la selección de archivo para subitems
   */
  async onFileSelectedForSubitem(event: Event, subitemId: number, activoId: number | null = null): Promise<void> {
    console.log('onFileSelectedForSubitem called with:', { subitemId, activoId });
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      try {
        // Crear un canvas para comprimir la imagen
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          img.src = e.target?.result as string;

          img.onload = async () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Establecer el tamaño máximo deseado
            const MAX_WIDTH = 800;
            const MAX_HEIGHT = 800;

            let width = img.width;
            let height = img.height;

            // Redimensionar si es necesario
            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }

            canvas.width = width;
            canvas.height = height;

            // Dibujar la imagen comprimida
            ctx?.drawImage(img, 0, 0, width, height);

            try {
              // Convertir canvas a blob
              const blob = await new Promise<Blob>((resolve) => {
                canvas.toBlob(
                  (blob) => {
                    resolve(blob as Blob);
                  },
                  'image/jpeg',
                  0.7
                );
              });

              // Crear FormData
              const formData = new FormData();
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
              });
              formData.append('file', compressedFile);

              const response = await this.uploadDataService
                .uploadFileFirebase(
                  formData,
                  `?path=solicitudes-visita/${this.solicitudId}/subitem-${subitemId}`
                )
                .toPromise();

              if (response && response.url) {
                // Guardar la URL de la imagen
                const imageUrl = response.url.startsWith('http')
                  ? response.url
                  : `${environment.apiUrl}/${response.url}`;

                // Agregar la imagen al subitem correspondiente
                const activoFijoFound = activoId ? this.findActivoFijoByActivoId(activoId) : null;
                this.agregarImagenASubitem(subitemId, imageUrl, activoFijoFound);

                // Mostrar mensaje de éxito
                this.snackBar.open('Imagen agregada exitosamente', 'Cerrar', {
                  duration: 3000,
                });

                // Limpiar el input file
                input.value = '';
              }
            } catch (error) {
              console.error('Error al subir la imagen:', error);
              this.snackBar.open('Error al subir la imagen', 'Cerrar', {
                duration: 3000,
              });
            }
          };
        };

        reader.readAsDataURL(file);
      } catch (error) {
        console.error('Error al procesar la imagen:', error);
        this.snackBar.open('Error al procesar la imagen', 'Cerrar', {
          duration: 3000,
        });
      }
    }
  }

  /**
   * Agrega una imagen al subitem correspondiente
   */
  // Filtrar por activo_fijo_id objetivo tanto en clima como en data_normal para 
  // evitar asignación indebida al primer activo de la lista
  private agregarImagenASubitem(subitemId: number, imageUrl: string, activoFijo: any = null): void {
    console.log('agregarImagenASubitem called with:', { subitemId, imageUrl, activoFijo });
    
    const targetActivoId = typeof activoFijo === 'object' ? activoFijo?.activo_fijo_id : activoFijo;

    if (this.checklistResponse?.is_climate && targetActivoId) {
      console.log('Buscando en activo fijo específico (clima):', targetActivoId);
      
      for (const currentActivo of this.checklistResponse.climate_data || []) {
        if (Number(currentActivo.activo_fijo_id) === Number(targetActivoId)) {
          for (const lista of currentActivo.checklist || []) {
            for (const item of lista.items || []) {
              const subitem = (item.subItems || []).find((sub: any) => Number(sub.id) === Number(subitemId));
              if (subitem) {
                if (!subitem.fotos) {
                  subitem.fotos = [];
                }
                subitem.fotos.push(imageUrl);
                this.actualizarChecklistEnBackend();
                return;
              }
            }
          }
        }
      }
    } else if (!this.checklistResponse?.is_climate && targetActivoId) {
      console.log('Buscando en activo fijo específico (normal):', targetActivoId);
      
      for (const currentActivo of this.checklistResponse?.data_normal || []) {
        if (Number(currentActivo.activo_fijo_id) === Number(targetActivoId)) {
          for (const lista of currentActivo.checklist || []) {
            for (const item of lista.items || []) {
              const subitem = (item.subItems || []).find((sub: any) => Number(sub.id) === Number(subitemId));
              if (subitem) {
                if (!subitem.fotos) {
                  subitem.fotos = [];
                }
                subitem.fotos.push(imageUrl);
                this.actualizarChecklistEnBackend();
                return;
              }
            }
          }
        }
      }
    } else {
      // Fallback si no viene un activo_fijo_id específico
      const listData = this.checklistResponse?.is_climate
        ? (this.checklistResponse?.climate_data || [])
        : (this.checklistResponse?.data_normal || []);

      for (const activo of listData) {
        for (const lista of activo.checklist || []) {
          for (const item of lista.items || []) {
            const subitem = (item.subItems || []).find((sub: any) => Number(sub.id) === Number(subitemId));
            if (subitem) {
              if (!subitem.fotos) {
                subitem.fotos = [];
              }
              subitem.fotos.push(imageUrl);
              this.actualizarChecklistEnBackend();
              return;
            }
          }
        }
      }
    }
  }

  /**
   * Elimina una imagen de un subitem
   */
  // 🛠️ FIX: Filtrar eliminación de imagen por el activo_fijo_id objetivo tanto para clima como para data_normal
  eliminarImagenSubitem(subitemId: number, imageIndex: number, activoId: number | null = null): void {
    console.log('eliminarImagenSubitem called with:', { subitemId, imageIndex, activoId });
    
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar la imagen adjunta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result: any) => {
      if (result.isConfirmed) {
        const targetActivoId = typeof activoId === 'object' ? (activoId as any)?.activo_fijo_id : activoId;

        if (this.checklistResponse?.is_climate && targetActivoId) {
          const activoFijoFound = this.findActivoFijoByActivoId(targetActivoId);
          if (activoFijoFound) {
            for (const lista of activoFijoFound.checklist || []) {
              for (const item of lista.items || []) {
                const subitem = (item.subItems || []).find((sub: any) => Number(sub.id) === Number(subitemId));
                if (subitem && subitem.fotos && subitem.fotos.length > imageIndex) {
                  subitem.fotos.splice(imageIndex, 1);
                  this.actualizarChecklistEnBackend();
                  this.snackBar.open('Imagen eliminada correctamente', 'Cerrar', {
                    duration: 3000,
                  });
                  return;
                }
              }
            }
          }
        } else if (!this.checklistResponse?.is_climate && targetActivoId) {
          for (const activo of this.checklistResponse?.data_normal || []) {
            if (Number(activo.activo_fijo_id) === Number(targetActivoId)) {
              for (const lista of activo.checklist || []) {
                for (const item of lista.items || []) {
                  const subitem = (item.subItems || []).find((sub: any) => Number(sub.id) === Number(subitemId));
                  if (subitem && subitem.fotos && subitem.fotos.length > imageIndex) {
                    subitem.fotos.splice(imageIndex, 1);
                    this.actualizarChecklistEnBackend();
                    this.snackBar.open('Imagen eliminada correctamente', 'Cerrar', {
                      duration: 3000,
                    });
                    return;
                  }
                }
              }
            }
          }
        } else {
          // Fallback para cuando no se especifica activoId
          const listData = this.checklistResponse?.is_climate
            ? (this.checklistResponse?.climate_data || [])
            : (this.checklistResponse?.data_normal || []);

          for (const activo of listData) {
            for (const lista of activo.checklist || []) {
              for (const item of lista.items || []) {
                const subitem = (item.subItems || []).find((sub: any) => Number(sub.id) === Number(subitemId));
                if (subitem && subitem.fotos && subitem.fotos.length > imageIndex) {
                  subitem.fotos.splice(imageIndex, 1);
                  this.actualizarChecklistEnBackend();
                  this.snackBar.open('Imagen eliminada correctamente', 'Cerrar', {
                    duration: 3000,
                  });
                  return;
                }
              }
            }
          }
        }
      }
    });
  }

  /**
   * Actualiza el checklist en el backend
   */
  private actualizarChecklistEnBackend(): void {
    this.solicitarVisitaService.updateChecklistVisita(Number(this.solicitudId), {
      is_climate: this.checklistResponse.is_climate,
      data: this.checklistResponse,
    }).subscribe((res: any) => {
      if (res.success) {
        console.log('Checklist actualizado correctamente');
      } else {
        console.error('Error al actualizar el checklist: ' + res.message);
      }
    });
  }

  /**
   * Cargar tipos de movimiento de inventario desde Dfontana
   */
  loadTiposMovimientoInventario() {
    console.log('🔄 Cargando tipos de movimiento de inventario desde Dfontana...');
    
    this.dfontanaService.getAllTypeInventoryInfo().subscribe({
      next: (response: any) => {
        console.log('✅ Respuesta de Dfontana:', response);
        if (response.success && response.inventoryList) {
          this.tiposMovimientoInventario = response.inventoryList;
          this.filteredTiposMovimiento = response.inventoryList;
          
          // Reiniciar el flag si el servicio responde bien
          this.isDfontanaDisabled = false; 
          console.log(`📦 ${response.inventoryList.length} tipos de movimiento cargados`);
        } else {
          console.warn('⚠️ Respuesta exitosa pero sin inventoryList');
        }
      },
      error: (error: any) => {
        console.error('❌ Error al cargar tipos de movimiento de inventario:', error);
        
        // Búsqueda profunda del flag. Al stringificar el error, garantizamos
        // atrapar 'DFONTANA_DISABLED' sin importar qué tan anidado venga el JSON del Backend.
        const rawError = JSON.stringify(error);
        
        if (rawError.includes('DFONTANA_DISABLED')) {
          console.log('⚠️ Dfontana desactivado intencionalmente (isActive = 0). Omitiendo alerta visual y bloqueando UI.');
          
          // Actualizamos el estado para que el HTML reaccione
          this.isDfontanaDisabled = true; 
          
          // Vaciamos las listas para prevenir que quede data "sucia"
          this.tiposMovimientoInventario = []; 
          this.filteredTiposMovimiento = [];
        } else {
          // Solo mostramos la alerta si el error es una caída real de red o credenciales
          this.snackBar.open(
            'Error al cargar tipos de movimiento de inventario desde Dfontana',
            'Cerrar',
            {
              duration: 3000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            }
          );
        }
      }
    });
  }

  /**
   * Filtrar tipos de movimiento de inventario según término de búsqueda
   */
  filterTiposMovimiento() {
    if (!this.tipoMovimientoSearchTerm || this.tipoMovimientoSearchTerm.trim() === '') {
      this.filteredTiposMovimiento = this.tiposMovimientoInventario;
      return;
    }

    const searchTerm = this.tipoMovimientoSearchTerm.toLowerCase();
    this.filteredTiposMovimiento = this.tiposMovimientoInventario.filter(tipo =>
      tipo.name?.toLowerCase().includes(searchTerm) ||
      tipo.code?.toLowerCase().includes(searchTerm)
    );
  }

  /**
   * Obtener el nombre del tipo de movimiento seleccionado
   */
  getTipoMovimientoNombre(code: string): string {
    if (!code) return '';
    const tipo = this.tiposMovimientoInventario.find(t => t.code === code);
    return tipo ? tipo.name : '';
  }

  /**
   * Procesar descuento de inventario en Dfontana
   */
  private procesarDescuentoInventario(tipoMovimiento: string): void {
    // Validar que el tipo de movimiento sea válido
    if (!isValidMovementType(tipoMovimiento)) {
      console.error(`❌ Tipo de movimiento "${tipoMovimiento}" no válido o no soportado`);
      this.snackBar.open(
        `El tipo de movimiento "${tipoMovimiento}" no es válido o no está soportado`,
        'Cerrar',
        {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        }
      );
      return;
    }

    // Obtener configuración del tipo de movimiento
    const movementConfig = getMovementTypeConfig(tipoMovimiento);
    console.log('📋 Configuración de movimiento:', movementConfig);

    // Recolectar todos los repuestos utilizados en la solicitud
    const repuestos: any[] = [];

    // Recorrer itemRepuestos para recolectar repuestos
    if (this.solicitud?.itemRepuestos && this.solicitud.itemRepuestos.length > 0) {
      this.solicitud.itemRepuestos.forEach((itemRep: any) => {
        // Solo incluir repuestos que tengan código Dfontana
        if (itemRep.repuesto?.codigo_dfontana) {
          repuestos.push({
            articleId: itemRep.repuesto.codigo_dfontana,
            description: itemRep.repuesto.articulo || '',
            count: itemRep.cantidad || 1,
            price: parseFloat(itemRep.repuesto.precio_venta) || 0,
            comment: `Usado en solicitud #${this.solicitudId}`
          });
        }
      });
    }

    // Si no hay repuestos, no hacer nada
    if (repuestos.length === 0) {
      console.log('⚠️ No hay repuestos con código Dfontana para descontar');
      this.snackBar.open(
        'No hay repuestos con código Dfontana para descontar',
        'Cerrar',
        {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        }
      );
      return;
    }

    // Construir el payload completo usando la configuración
    let payload: any;
    try {
      payload = buildDfontanaPayload(
        tipoMovimiento,
        repuestos,
        Number(this.solicitudId),
        this.solicitud?.client?.email
      );
    } catch (error: any) {
      console.error('❌ Error al construir payload:', error);
      this.snackBar.open(
        `Error al construir datos: ${error.message}`,
        'Cerrar',
        {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        }
      );
      return;
    }

    console.log('📤 Enviando descuento a Dfontana:', payload);
    console.log(`📍 Endpoint: ${movementConfig?.endpoint === 'insertSkipCentralization' ? 'InsertSkipCentralization' : 'Insert'}`);

    // Determinar qué método usar según el tipo de movimiento
    const serviceMethod = movementConfig?.endpoint === 'insertSkipCentralization'
      ? this.dfontanaService.insertInventoryMovementSkipCentralization(payload)
      : this.dfontanaService.insertInventoryMovement(payload);

    // Llamar al servicio para registrar el movimiento
    serviceMethod.subscribe({
      next: (responseDfontana: any) => {
        console.log('📥 Respuesta recibida de Dfontana:', responseDfontana);

        // IMPORTANTE: Guardar SIEMPRE la respuesta de Dfontana, sea exitosa o no
        // Esto nos permite tener un log completo de todos los intentos
        const updateData = {
          response_dfontana: JSON.stringify({
            ...responseDfontana,
            timestamp: new Date().toISOString(),
            tipoMovimiento: tipoMovimiento,
            solicitudId: this.solicitudId
          })
        };

        console.log('💾 Guardando respuesta en BD:', updateData);

        this.solicitarVisitaService
          .updateSolicitudVisita(Number(this.solicitudId), updateData)
          .subscribe({
            next: () => {
              console.log('✅ Respuesta de Dfontana guardada en solicitud');

              // Mostrar modal según el resultado
              if (responseDfontana.success) {
                // Modal de éxito
                Swal.fire({
                  icon: 'success',
                  title: 'Descuento Registrado',
                  html: `
                    <p>El descuento de inventario se registró exitosamente en Dfontana.</p>
                    <hr>
                    <p><strong>Documento:</strong> #${responseDfontana.number || 'N/A'}</p>
                    <p><strong>Tipo:</strong> ${responseDfontana.documentType || tipoMovimiento}</p>
                    <p><strong>Repuestos:</strong> ${repuestos.length}</p>
                  `,
                  confirmButtonText: 'Aceptar',
                  confirmButtonColor: '#3085d6'
                });
              } else {
                // Modal de error: Dfontana rechazó el descuento
                const exceptionMsg = responseDfontana.exceptionMessage || responseDfontana.message || 'Error desconocido';

                Swal.fire({
                  icon: 'error',
                  title: 'El descuento NO se aplicó en Dfontana',
                  html: `
                    <div style="text-align: left;">
                      <p><strong>Motivo:</strong></p>
                      <p style="color: #e74c3c; margin: 10px 0; padding: 10px; background: #fadbd8; border-radius: 5px;">
                        ${exceptionMsg}
                      </p>
                      <hr style="margin: 15px 0;">
                      <p><strong>Detalles técnicos:</strong></p>
                      <ul style="font-size: 0.9em; color: #555;">
                        <li><strong>Tipo de movimiento:</strong> ${tipoMovimiento}</li>
                        <li><strong>Repuestos intentados:</strong> ${repuestos.length}</li>
                        <li><strong>Total:</strong> $${payload.total?.toLocaleString('es-CL') || '0'}</li>
                      </ul>
                      <hr style="margin: 15px 0;">
                      <p style="color: #d35400; font-weight: bold;">⚠️ ACCIÓN REQUERIDA:</p>
                      <p>Debe revisar en <strong>Dfontana</strong> y realizar el descuento de inventario <strong>manualmente</strong>.</p>
                      <p style="font-size: 0.9em; color: #555;">
                        Solicitud: <strong>#${this.solicitudId}</strong><br>
                        Documento ID: <strong>SOL-${this.solicitudId}</strong>
                      </p>
                    </div>
                  `,
                  confirmButtonText: 'Entendido - Revisaré en Dfontana',
                  confirmButtonColor: '#e74c3c',
                  width: '600px'
                });

                console.warn('⚠️ Dfontana respondió sin éxito:', responseDfontana);
              }
            },
            error: (error: any) => {
              console.error('❌ Error al guardar respuesta Dfontana en BD:', error);
              console.error('Datos que se intentaron guardar:', updateData);

              // Modal de advertencia: No se pudo guardar en BD
              if (responseDfontana.success) {
                // Descuento exitoso pero no se guardó en BD
                Swal.fire({
                  icon: 'warning',
                  title: 'Descuento Registrado con Advertencia',
                  html: `
                    <p>El descuento se registró en Dfontana pero no se pudo guardar la respuesta en la solicitud.</p>
                    <hr>
                    <p><strong>Documento Dfontana:</strong> #${responseDfontana.number || 'N/A'}</p>
                    <p><strong>Error BD:</strong> ${error.message || 'Error desconocido'}</p>
                    <p style="font-size: 0.85em; color: #777; margin-top: 10px;">
                      Por favor, informe a soporte técnico sobre este error.
                    </p>
                  `,
                  confirmButtonText: 'Entendido',
                  confirmButtonColor: '#f39c12'
                });
              } else {
                // Descuento fallido Y no se guardó en BD
                const exceptionMsg = responseDfontana.exceptionMessage || responseDfontana.message || 'Error desconocido';

                Swal.fire({
                  icon: 'error',
                  title: 'Error Crítico en Descuento',
                  html: `
                    <div style="text-align: left;">
                      <p><strong>El descuento NO se aplicó en Dfontana Y no se pudo guardar el log.</strong></p>
                      <p style="color: #e74c3c; margin: 10px 0; padding: 10px; background: #fadbd8; border-radius: 5px;">
                        ${exceptionMsg}
                      </p>
                      <p style="font-size: 0.85em; color: #777; margin-top: 10px;">
                        <strong>Error adicional al guardar:</strong> ${error.message || 'Error desconocido'}
                      </p>
                      <hr style="margin: 15px 0;">
                      <p style="color: #d35400; font-weight: bold;">⚠️ ACCIÓN REQUERIDA:</p>
                      <p>Debe revisar en <strong>Dfontana</strong> y realizar el descuento de inventario <strong>manualmente</strong>.</p>
                      <p>Solicitud: <strong>#${this.solicitudId}</strong></p>
                    </div>
                  `,
                  confirmButtonText: 'Entendido - Revisaré en Dfontana',
                  confirmButtonColor: '#e74c3c',
                  width: '600px'
                });
              }
            }
          });
      },
      error: (error: any) => {
        console.error('❌ Error al registrar descuento en Dfontana:', error);

        // Intentar guardar el error en la base de datos para trazabilidad
        const errorLog = {
          success: false,
          error: true,
          message: error.error?.message || error.message || 'Error de comunicación con Dfontana',
          exceptionMessage: error.error?.exceptionMessage || error.error?.error || '',
          statusCode: error.status,
          timestamp: new Date().toISOString(),
          tipoMovimiento: tipoMovimiento,
          solicitudId: this.solicitudId,
          repuestosIntentados: repuestos.length
        };

        const updateData = {
          response_dfontana: JSON.stringify(errorLog)
        };

        console.log('💾 Intentando guardar log de error en BD:', updateData);

        // Intentar guardar el error (pero no bloqueamos el modal si falla)
        this.solicitarVisitaService
          .updateSolicitudVisita(Number(this.solicitudId), updateData)
          .subscribe({
            next: () => {
              console.log('✅ Log de error guardado en solicitud');
            },
            error: (saveError: any) => {
              console.error('❌ No se pudo guardar el log de error:', saveError);
            }
          });

        // Modal de error: Error de comunicación o técnico
        const errorMsg = error.error?.message || error.message || 'Error de comunicación con Dfontana';
        const errorDetails = error.error?.exceptionMessage || '';

        Swal.fire({
          icon: 'error',
          title: 'Error al Conectar con Dfontana',
          html: `
            <div style="text-align: left;">
              <p><strong>No se pudo registrar el descuento de inventario.</strong></p>
              <p style="color: #e74c3c; margin: 10px 0; padding: 10px; background: #fadbd8; border-radius: 5px;">
                ${errorMsg}
              </p>
              ${errorDetails ? `
                <p style="font-size: 0.85em; color: #777; margin-top: 10px;">
                  <strong>Detalles:</strong> ${errorDetails}
                </p>
              ` : ''}
              <hr style="margin: 15px 0;">
              <p><strong>Información del intento:</strong></p>
              <ul style="font-size: 0.9em; color: #555;">
                <li><strong>Tipo de movimiento:</strong> ${tipoMovimiento}</li>
                <li><strong>Repuestos:</strong> ${repuestos.length}</li>
                <li><strong>Solicitud:</strong> #${this.solicitudId}</li>
                ${error.status ? `<li><strong>Código HTTP:</strong> ${error.status}</li>` : ''}
              </ul>
              <hr style="margin: 15px 0;">
              <p style="color: #d35400; font-weight: bold;">⚠️ ACCIÓN REQUERIDA:</p>
              <p>Debe revisar en <strong>Dfontana</strong> y realizar el descuento de inventario <strong>manualmente</strong>.</p>
              <p style="font-size: 0.85em; color: #555;">
                Posibles causas: Error de red, timeout, credenciales inválidas, o servicio Dfontana no disponible.
              </p>
            </div>
          `,
          confirmButtonText: 'Entendido - Revisaré en Dfontana',
          confirmButtonColor: '#e74c3c',
          width: '600px'
        });
      }
    });
  }

  // --- MÉTODOS PARA GESTIÓN DE ACTIVOS FIJOS (OPERATIVOS / NO OPERATIVOS) ---

  /**
   * Busca el objeto activo fijo dentro de la estructura de respuesta.
   */
  private findActivoFijo(id: number) {
    if (this.checklistResponse?.climate_data) {
      // Comparación flexible (==) por si viene como string
      return this.checklistResponse.climate_data.find((a: any) => a.activo_fijo_id == id);
    }
    return null;
  }
  
  /**
   * Returns the activoFijoLocal detail for a given activo_fijo_id,
   * using the already-loaded solicitud.local.activoFijoLocales array.
   */
  getActivoDetail(activoFijoId: any): any {
    return this.solicitud?.local?.activoFijoLocales?.find(
      (item: any) => item.id.toString() === activoFijoId.toString()
    ) || null;
  }

  /**
   * Activa el input de archivo oculto correspondiente al activo fijo seleccionado.
   */
  triggerFileInputActivo(activoFijoId: number) {
    const element = document.getElementById('fileInput-activo-' + activoFijoId) as HTMLElement;
    if (element) {
      element.click();
    }
  }
  
  /**
   * Maneja la selección del archivo, lo empaqueta en FormData y lo sube a Firebase.
   */
  onFileSelectedForActivo(event: any, activoFijoId: number) {
    const file: File = event.target.files[0];
    
    if (file) {
      this.loading = true;
      
      // Crear el FormData y adjuntar el archivo con la clave 'file'
      // (Es obligatorio porque el servicio valida: const file = formData.get('file'))
      const formData = new FormData();
      formData.append('file', file);

      // Llamar al servicio pasando el FormData y el path
      this.uploadDataService.uploadFileFirebase(formData, 'checklist/activos').subscribe({
        next: (response: any) => {
          // La respuesta ya viene procesada por el pipe/map del servicio
          const url = response.url;
          const activo = this.findActivoFijo(activoFijoId);
          
          if (activo) {
            // Actualizamos la vista inmediatamente
            activo.photo_not_operational = url;
            
            // Guardamos el cambio en el backend
            this.guardarEstadoActivo(activo);
          }
          this.loading = false;
        },
        error: (error: any) => {
          console.error('Error al subir imagen de activo a Firebase:', error);
          this.snackBar.open('Error al subir la imagen.', 'Cerrar', { duration: 3000 });
          this.loading = false;
        }
      });
    }
  }

  /**
   * Elimina la imagen de evidencia del activo fijo.
   */
  eliminarImagenActivo(activoFijoId: number) {
    // Confirmación antes de eliminar foto adjunta
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar la imagen adjunta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result: any) => {
      if (result.isConfirmed) {
        const activo = this.findActivoFijo(activoFijoId);
        if (activo) {
          activo.photo_not_operational = null;
          this.guardarEstadoActivo(activo);
          this.snackBar.open('Imagen eliminada correctamente', 'Cerrar', { duration: 3000 });
        }
      }
    });
  }

  /**
   * Actualiza la observación del activo.
   * Se recomienda usar un debounce si se llama en cada tecla, pero para ngModelChange directo funciona.
   */
  actualizarObservacionActivo(activoFijoId: number, observacion: string) {
    const activo = this.findActivoFijo(activoFijoId);
    if (activo) {
      activo.observacionesEstado = observacion;
      // Opcional: Implementar debounce aquí si el tráfico es alto
      this.guardarEstadoActivo(activo);
    }
  }
  
  
  /**
   * Envía la actualización del activo al backend.
   */
  private guardarEstadoActivo(activo: any) {
    const payload = {
      activoFijoUpdate: {
        // IMPORTANTE: Enviamos el campo activo_fijo_id para identificar el activo en el backend, no "id".
        activo_fijo_id: activo.activo_fijo_id,
        photo_not_operational: activo.photo_not_operational,
        observacionesEstado: activo.observacionesEstado,
        estadoOperativo: activo.estadoOperativo,
        operativo_sin_acceso: activo.operativo_sin_acceso // Nuevo campo para el estado sin_acceso
      }
    };

    this.solicitarVisitaService.updateChecklistVisita(Number(this.solicitudId), payload)
      .subscribe({
        next: () => console.log('Activo actualizado correctamente'),
        error: (err: any) => console.error('Error al guardar activo:', err)
      });
  }

  /**
   * Actualiza el indicador operativo_sin_acceso del activo.
   */
  actualizarOperativoSinAcceso(activoFijoId: number, operativo: boolean) {
    const activo = this.findActivoFijo(activoFijoId);
    if (activo) {
      activo.operativo_sin_acceso = operativo;
      this.guardarEstadoActivo(activo);
    }
  }

  openStatusMenu(subItem: any, activoId: number | null = null) {
    // if (this.solicitud?.status === 'validada' || this.isRechazada) return;
  
    this.tempNuevoEstado = subItem.estado;
  
    const dialogRef = this.dialog.open(this.statusDialog, {
      width: '400px',
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'custom-status-dialog'
    });
  
    dialogRef.afterClosed().subscribe((nuevoEstado:any) => {
      if (nuevoEstado && nuevoEstado !== subItem.estado) {
        this.cambiarEstadoSubItem(subItem, nuevoEstado, activoId);
      }
    });
  }
  
  private cambiarEstadoSubItem(subItem: any, nuevoEstado: string, activoId: number | null) {
    // Actualizar en el objeto local para feedback inmediato
    subItem.estado = nuevoEstado;
  
    // Preparar el payload para el backend
    const payload = {
      subItemId: subItem.id,
      estado: nuevoEstado,
      // Si es clima, necesitamos pasar el activoId para que el backend localice el subitem
      activoId: activoId 
    };
  
    // Usar el método existente para persistir el cambio
    this.solicitarVisitaService.updateChecklistVisita(Number(this.solicitudId), payload)
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.snackBar.open(`Estado cambiado a ${nuevoEstado.replace('_', ' ')}`, 'Cerrar', {
              duration: 2000
            });
            // Recalcular total si el cambio de estado influye en los repuestos (opcional)
            this.calcularTotalFinal();
          }
        },
        error: (err: any) => {
          console.error('Error al cambiar estado:', err);
          this.snackBar.open('No se pudo actualizar el estado', 'Cerrar', { duration: 3000 });
          // Revertir cambio local en caso de error
          this.loadSolicitud(); 
        }
      });
  }

  reprogramarVisita() {
    if (this.solicitudForm.get('fechaVisita')?.invalid || !this.solicitudForm.get('tecnico_asignado_id')?.value) {
      this.snackBar.open('Debe asignar un técnico y una fecha de visita', 'Cerrar', {
        duration: 4000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    Swal.fire({
      title: '¿Reprogramar Visita?',
      text: 'La solicitud se asignará al técnico con la nueva fecha y volverá al flujo.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, reprogramar',
      cancelButtonText: 'Cancelar'
    }).then((result: any) => {
      if (result.isConfirmed) {
        // Normalización de campos opcionales para evitar strings vacíos o NaN en TypeORM
        const rawTecnico2 = this.solicitudForm.get('tecnico_asignado_id_2')?.value;
        const rawSector = this.solicitudForm.get('sectorTrabajoId')?.value;
        const rawEspecialidad = this.solicitudForm.get('especialidad')?.value;

        const payload = {
          tecnico_asignado_id: Number(this.solicitudForm.get('tecnico_asignado_id')?.value),
          tecnico_asignado_id_2: (rawTecnico2 !== null && rawTecnico2 !== '') ? Number(rawTecnico2) : null,
          sectorTrabajoId: (rawSector !== null && rawSector !== '') ? Number(rawSector) : null,
          especialidad: (rawEspecialidad !== null && rawEspecialidad !== '') ? Number(rawEspecialidad) : null,
          
          fechaVisita: this.solicitudForm.get('fechaVisita')?.value,
          programada_por_id: this.authService.currentUserValue?.id ? Number(this.authService.currentUserValue.id) : null
        };

        this.solicitarVisitaService.programarSolicitud(Number(this.solicitudId), payload).subscribe({
          next: () => {
            Swal.fire('Éxito', 'Visita reprogramada correctamente', 'success');
            this.router.navigate(['/transacciones/solicitudes-de-visita/atendidas-en-proceso']);
          },
          error: (err: any) => Swal.fire('Error', 'No se pudo reprogramar la visita', 'error')
        });
      }
    });
  }

  // Formateador para la vista
  formatStatus(status: string | undefined): string {
    if (!status) return '';
    const formatted = status.replace(/_/g, ' ');
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }

  // Formateador estricto para inputs tipo datetime-local (HTML5)
  private formatForDateTimeLocal(dateString: string): string {
    if (!dateString) return '';
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return '';
    
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  /**
   * Obtiene el precio específico del cliente. Si no existe, retorna el base.
   */
  getPrecioRepuestoCliente(repuesto: any, tipo: 'venta' | 'compra' = 'venta'): number {
    if (!repuesto) return 0;
    const clienteId = this.solicitud?.client?.id;
    
    if (clienteId && repuesto.clienteRepuestos && Array.isArray(repuesto.clienteRepuestos)) {
      const precioCliente = repuesto.clienteRepuestos.find((cr: any) => 
        cr.cliente?.id === clienteId || cr.cliente_id === clienteId
      );
      if (precioCliente) {
        return tipo === 'venta' ? Number(precioCliente.precio_venta) : Number(precioCliente.precio_compra);
      }
    }
    
    return tipo === 'venta' ? Number(repuesto.precio_venta || repuesto.precio || 0) : Number(repuesto.precio_compra || 0);
  }

  // ==========================================================
  // GESTIÓN DE ZOOM DE IMÁGENES (LIGHTBOX)
  // ==========================================================
  
  openImageInLightbox(imageUrl: string, event?: Event): void {
    if (event) event.stopPropagation();
    if (!imageUrl || imageUrl.includes('no-image.png')) return;
    
    // Abrimos el nuevo modal compartido a pantalla completa
    this.dialog.open(AdvancedImageViewerComponent, {
      data: { url: imageUrl },
      panelClass: 'full-screen-image-dialog',
      width: '100vw',
      height: '100vh',
      hasBackdrop: false
    });
  }

  /**
   * Pasa el estado de la solicitud a 'finalizada' si el técnico completó el trabajo con éxito.
   */
  finalizarServicioManual(): void {
    if (this.isReadOnly) return;

    Swal.fire({
      title: '¿Finalizar Servicio?',
      text: '¿Confirmas que el técnico ya realizó el trabajo en terreno y deseas cambiar el estado a "Finalizada"?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, finalizar servicio',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#2e7d32',
      cancelButtonColor: '#757575'
    }).then((result : any) => {
      if (result.isConfirmed) {
        this.loading = true;
        
        // El backend acepta actualizaciones de estado directas mediante updateSolicitudVisita
        this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), {
          status: 'finalizada',
          fecha_hora_fin_servicio: new Date()
        }).subscribe({
          next: () => {
            this.snackBar.open('Servicio marcado como Finalizado exitosamente.', 'Cerrar', { duration: 3000 });
            this.loadSolicitud(); // Recargar datos e inicializar stepper
          },
          error: (error: any) => {
            console.error('Error al finalizar el servicio:', error);
            this.snackBar.open('No se pudo finalizar la solicitud. Verifique los datos.', 'Cerrar', { duration: 4000 });
            this.loading = false;
          }
        });
      }
    });
  }

  /**
   * Pasa el estado de la solicitud a 'atendida_en_proceso' si el trabajo quedó incompleto, 
   * registrando el motivo en el campo observaciones sin sobreescribir el historial.
   */
  dejarAtendidaEnProcesoManual(): void {
    if (this.isReadOnly) return;

    Swal.fire({
      title: 'Pausar Servicio (Atendida en Proceso)',
      text: 'Indique detalladamente la causa raíz o motivo por el cual el servicio queda incompleto:',
      input: 'textarea',
      inputPlaceholder: 'Ej: Falta repuesto crítico de climatización / Sin acceso al local...',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Guardar en Proceso',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#f57c00',
      cancelButtonColor: '#757575',
      inputValidator: (value) => {
        if (!value || value.trim() === '') {
          return '¡El motivo del estado es mandatorio!';
        }
        return null;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        const motivo = result.value;
        const observacionesPrevias = this.solicitudForm.get('observaciones')?.value || '';
        
        // Sanitización y formateo de observaciones para consistencia en MariaDB
        const nuevasObservaciones = observacionesPrevias 
          ? `${observacionesPrevias}\n\n[Pausa Manual - Atendida en Proceso]: ${motivo.trim()}`
          : `[Pausa Manual - Atendida en Proceso]: ${motivo.trim()}`;

        this.solicitarVisitaService.updateSolicitudVisita(Number(this.solicitudId), {
          status: 'atendida_en_proceso',
          observaciones: nuevasObservaciones
        }).subscribe({
          next: () => {
            this.snackBar.open('Solicitud cambiada a Atendida en Proceso correctamente.', 'Cerrar', { duration: 3000 });
            this.loadSolicitud(); // Sincronizar UI
          },
          error: (error: any) => {
            console.error('Error al pausar la solicitud:', error);
            this.snackBar.open('Error al actualizar el estado de la solicitud.', 'Cerrar', { duration: 4000 });
            this.loading = false;
          }
        });
      }
    });
  }

  // Método auxiliar de sanitización
  private sanitizeSubItemFotos(fotos: any[]): string[] {
    if (!Array.isArray(fotos)) return [];
    return fotos.filter((foto: string) => !!foto && foto !== 'undefined' && foto !== 'null');
  }
}
